import _Checkbox from 'antd/es/checkbox';
import { globalConfig } from 'antd/es/config-provider';
import styled, { css, createGlobalStyle, keyframes, useTheme } from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { SmallChevronDown, Checkmark, MagnifyingGlass, Calendar, Error as Error$1, Document, Cross, Loading, ChevronDown, ExternalLink, Info, Warning, SmallChevronUp, ArrowCircle, ChevronLeft, CircleCross, CheckmarkCircle } from '@helloworld1812/ws-icons';
import { Avatar as Avatar$1, getColor, FlexBox, Typography, colors, Text, ButtonNew, Dropdown, Button, Box, theme, Modal } from '@helloworld1812/ws-components';
import { useFeatureIsOn } from '@helloworld1812/ws-growthbook';
import _Select from 'antd/es/select';
import React, { forwardRef, useState, useMemo, useCallback, useImperativeHandle, useRef, useEffect, cloneElement } from 'react';
import _Input from 'antd/es/input';
import { colors as colors$1, getColor as getColor$1 } from '@helloworld1812/ws-theme';
import { IntlTelInput } from '@helloworld1812/workstream-ui';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';
import { noop, isFunction, capitalize, defaults, omit, debounce, toArray } from 'lodash';
import classNames from 'classnames';
import { CheckOutlined } from '@ant-design/icons';
import _Col from 'antd/es/col';
import _Row from 'antd/es/row';
import _Drawer from 'antd/es/drawer';
import _Space from 'antd/es/space';
import _InputNumber from 'antd/es/input-number';
import _message from 'antd/es/message';
import _Upload from 'antd/es/upload';
import _Table from 'antd/es/table';
import _Tooltip from 'antd/es/tooltip';
import _Menu from 'antd/es/menu';
import _Alert from 'antd/es/alert';
import { serialize } from 'object-to-formdata';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import _Radio from 'antd/es/radio';
import _Switch from 'antd/es/switch';
import _Spin from 'antd/es/spin';
import _Pagination from 'antd/es/pagination';
import _Dropdown from 'antd/es/dropdown';
import ReactInfiniteScrollComponent from 'react-infinite-scroll-component';
import { useClickOutside } from '@helloworld1812/ws-hooks';
import useUrlState from '@ahooksjs/use-url-state';
import { useDebounce } from 'ahooks';
import _Popover from 'antd/es/popover';
import _Collapse from 'antd/es/collapse';
import _Tag from 'antd/es/tag';
import _TreeSelect, { TreeNode } from 'antd/es/tree-select';
import _Divider from 'antd/es/divider';
import _notification from 'antd/es/notification';

const Checkbox = /*#__PURE__*/styled(_Checkbox).withConfig({
  displayName: "checkbox__Checkbox",
  componentId: "sc-1eaerrq-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["font-weight:normal;font-size:14px;font-family:'Plus Jakarta Sans',sans-serif;display:flex;align-items:center;& .", "-checkbox{top:unset;}& .", "-checkbox-inner{width:18px;height:18px;border-radius:4px;&:after{left:4px;top:7px;width:5px;height:9px;}}& .", "-checkbox-indeterminate .", "-checkbox-inner:after{left:8px;top:8px;width:10px;height:2px;background-color:", ";}& .", "-checkbox-checked .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}&.", "-checkbox-wrapper:hover .", "-checkbox-inner,& .", "-checkbox:hover .", "-checkbox-inner,& .", "-checkbox-input:focus + .", "-checkbox-inner{border-color:", ";}& .", "-checkbox-checked::after{border:unset;}& .", "-checkbox-disabled .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}& .", "-checkbox-disabled.", "-checkbox-checked .", "-checkbox-inner::after{border-color:white;}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.white, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray400, props.theme.colors.gray400, antdCssPrefix, antdCssPrefix, antdCssPrefix);
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$k =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$d = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$c = fails$d;

// Thank's IE8 for his funny defineProperty
var descriptors = !fails$c(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectPropertyIsEnumerable = {};

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw$1 = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$b = fails$d;
var classof$7 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$b(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$7(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$4 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

var isObject$9 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var isObject$8 = isObject$9;

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$8(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$8(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$8(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$8(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has$b = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var global$j = global$k;
var isObject$7 = isObject$9;

var document$2 = global$j.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$7(document$2) && isObject$7(document$2.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$2.createElement(it) : {};
};

var DESCRIPTORS$8 = descriptors;
var fails$a = fails$d;
var createElement$1 = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$8 && !fails$a(function () {
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$7 = descriptors;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$3 = toIndexedObject$4;
var toPrimitive$1 = toPrimitive$2;
var has$a = has$b;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$7 ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPrimitive$1(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$a(O, P)) return createPropertyDescriptor$2(!propertyIsEnumerableModule$1.f.call(O, P), O[P]);
};

var objectDefineProperty = {};

var isObject$6 = isObject$9;

var anObject$b = function (it) {
  if (!isObject$6(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$a = anObject$b;
var toPrimitive = toPrimitive$2;

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject$a(O);
  P = toPrimitive(P, true);
  anObject$a(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$8 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$6 = {exports: {}};

var global$i = global$k;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$8;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$7(global$i, key, value);
  } catch (error) {
    global$i[key] = value;
  } return value;
};

var global$h = global$k;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$h[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$3 = store$2.inspectSource;

var global$g = global$k;
var inspectSource$2 = inspectSource$3;

var WeakMap$1 = global$g.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$2(WeakMap$1));

var shared$2 = {exports: {}};

var store$1 = sharedStore;

(shared$2.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var shared$1 = shared$2.exports;
var uid$1 = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$f = global$k;
var isObject$5 = isObject$9;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$8;
var objectHas = has$b;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var WeakMap = global$f.WeakMap;
var set$1, get, has$9;

var enforce = function (it) {
  return has$9(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set$1 = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$9 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    createNonEnumerableProperty$6(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$9 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has$9,
  enforce: enforce,
  getterFor: getterFor
};

var global$e = global$k;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$8;
var has$8 = has$b;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$2 = internalState;

var getInternalState$2 = InternalStateModule$2.get;
var enforceInternalState = InternalStateModule$2.enforce;
var TEMPLATE = String(String).split('String');

(redefine$6.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$8(value, 'name')) createNonEnumerableProperty$5(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global$e) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$5(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$2(this).source || inspectSource$1(this);
});

var global$d = global$k;

var path$1 = global$d;

var path = path$1;
var global$c = global$k;

var aFunction$7 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$6 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$7(path[namespace]) || aFunction$7(global$c[namespace])
    : path[namespace] && path[namespace][method] || global$c[namespace] && global$c[namespace][method];
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$4 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil)(argument);
};

var toInteger$3 = toInteger$4;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$4 = function (argument) {
  return argument > 0 ? min$2(toInteger$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toInteger$2 = toInteger$4;

var max$1 = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger$2(index);
  return integer < 0 ? max$1(integer + length, 0) : min$1(integer, length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toLength$3 = toLength$4;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = toLength$3(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var has$7 = has$b;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$7(hiddenKeys$2, key) && has$7(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$7(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$6;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$9 = anObject$b;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$9(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has$6 = has$b;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$6(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$9 = fails$d;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$9(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$b = global$k;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$8;
var redefine$5 = redefine$6.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$b;
  } else if (STATIC) {
    target = global$b[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$b[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$5(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var requireObjectCoercible$4 = requireObjectCoercible$6;

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return Object(requireObjectCoercible$4(argument));
};

var DESCRIPTORS$4 = descriptors;
var fails$8 = fails$d;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$3 = toObject$4;
var IndexedObject$1 = indexedObject;

var nativeAssign = Object.assign;
var defineProperty$3 = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
var objectAssign = !nativeAssign || fails$8(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$4 && nativeAssign({ b: 1 }, nativeAssign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys$1(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject$3(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$1(S).concat(getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$4 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

var $$a = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$$a({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const UnshadowedContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "card__UnshadowedContainer",
  componentId: "sc-1tkweqd-0"
})(["display:flex;flex-direction:column;border-radius:12px;background-color:white;"]);
function UnshadowedCard(_a) {
  var {
      className,
      children
    } = _a,
    otherProps = __rest(_a, ["className", "children"]);
  return jsx(UnshadowedContainer, Object.assign({
    className: className
  }, otherProps, {
    children: children
  }));
}

function Card(_a) {
  var {
      shadowed = false,
      className
    } = _a,
    otherProps = __rest(_a, ["shadowed", "className"]);
  return jsx(UnshadowedCard, Object.assign({
    className: className
  }, otherProps));
}
const CardV2 = /*#__PURE__*/styled(Card).withConfig({
  displayName: "card-v2__CardV2",
  componentId: "sc-rfuu2j-0"
})(["", ";padding:20px;"], props => props.shadowed && 'box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)');

const AvatarWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "avatar__AvatarWrapper",
  componentId: "sc-ysa4ln-0"
})(["background-color:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:60px;width:60px;height:60px;font-size:20px;font-weight:600;color:white;background-image:", ";background-size:cover;background-position:center;"], ({
  theme
}) => theme.getColor('blue500'), ({
  src
}) => src ? `url(${src})` : 'none');
/** @deprecated, prefer to use Avatar from ws-components */
const Avatar = props => {
  const isDsAdoptAvatarOn = useFeatureIsOn('ds-adopt-avatar');
  const {
    children,
    src,
    style = {},
    wsWrapper = isDsAdoptAvatarOn,
    alt
  } = props;
  if (wsWrapper) {
    if (src && !alt) {
      console.warn('[Avatar(hr-ui)] must have alt prop defined if src is defined! Now src is used as alt.');
    }
    return jsx(Avatar$1, Object.assign({
      "$bgColor": "blue500",
      "$size": "large",
      alt: src
    }, props));
  }
  return src ? jsx(AvatarWrapper, {
    style: style,
    src: src
  }) : jsx(AvatarWrapper, Object.assign({
    style: style
  }, {
    children: children
  }));
};

var $$9 = _export;
var DESCRIPTORS$3 = descriptors;
var global$a = global$k;
var has$5 = has$b;
var isObject$4 = isObject$9;
var defineProperty$2 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$a.Symbol;

if (DESCRIPTORS$3 && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$2(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject$4(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has$5(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$9({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var fails$7 = fails$d;

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$7(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';

var global$9 = global$k;
var shared = shared$2.exports;
var has$4 = has$b;
var uid = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global$9.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol$g = function (name) {
  if (!has$4(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has$4(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var DESCRIPTORS$2 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$8 = anObject$b;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = DESCRIPTORS$2 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$6;

var html$2 = getBuiltIn$4('document', 'documentElement');

var anObject$7 = anObject$b;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

var wellKnownSymbol$f = wellKnownSymbol$g;
var create$1 = objectCreate;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$6 = fails$d;

var correctPrototypeGetter = !fails$6(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var has$3 = has$b;
var toObject$2 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject$2(O);
  if (has$3(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var getPrototypeOf$1 = objectGetPrototypeOf;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$8;
var has$2 = has$b;
var wellKnownSymbol$e = wellKnownSymbol$g;

var ITERATOR$5 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype$2 == undefined) IteratorPrototype$2 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has$2(IteratorPrototype$2, ITERATOR$5)) {
  createNonEnumerableProperty$3(IteratorPrototype$2, ITERATOR$5, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var has$1 = has$b;
var wellKnownSymbol$d = wellKnownSymbol$g;

var TO_STRING_TAG$3 = wellKnownSymbol$d('toStringTag');

var setToStringTag$3 = function (it, TAG, STATIC) {
  if (it && !has$1(it = STATIC ? it : it.prototype, TO_STRING_TAG$3)) {
    defineProperty$1(it, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$2 = setToStringTag$3;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isObject$3 = isObject$9;

var aPossiblePrototype$1 = function (it) {
  if (!isObject$3(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

var anObject$6 = anObject$b;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$6(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$8 = _export;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$3;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$8;
var redefine$4 = redefine$6.exports;
var wellKnownSymbol$c = wellKnownSymbol$g;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$c('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$4] != 'function') {
          createNonEnumerableProperty$2(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    createNonEnumerableProperty$2(IterablePrototype, ITERATOR$4, defaultIterator);
  }
  Iterators$3[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$4(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$8({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var toIndexedObject = toIndexedObject$4;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineIterator = defineIterator$1;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var global$8 = global$k;
var DOMIterables = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$8;
var wellKnownSymbol$b = wellKnownSymbol$g;

var ITERATOR$3 = wellKnownSymbol$b('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$b('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$8[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}

const GlobalStyle$5 = /*#__PURE__*/createGlobalStyle(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css([".new-select-antd.", "-select-dropdown{box-shadow:0px 2px 2px rgb(0 0 0 / 8%),0px 4px 8px rgb(0 0 0 / 12%);border-radius:8px;padding:8px 0;}.new-select-antd .", "-select-item-option{padding:12px 16px;line-height:24px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;&:hover{background-color:", ";}&.", "-select-item-option-selected,&.", "-select-item-option-active{background-color:transparent;&:hover{background-color:", ";}}p{display:inline;}&.", "-select-item-option-selected p{font-weight:600 !important;}&.", "-select-item-option-selected:hover{background-color:", ";}}.", "-select-item-option-disabled{background-color:", ";:hover{background-color:", " !important;cursor:not-allowed;}p{color:", " !important;}}"], antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray100'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray100'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray100'), antdCssPrefix, ({
    theme
  }) => theme.getColor('gray200'), ({
    theme
  }) => theme.getColor('gray200'), getColor('gray400'));
});
const StyledSelect = /*#__PURE__*/styled(_Select).withConfig({
  displayName: "select-v2__StyledSelect",
  componentId: "sc-xd5lrk-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    hidedescriptiononselecteditem,
    showSelectedItemDuringDropDown
  } = props;
  return css(["&.", "-select{&:not(.", "-select-customize-input).", "-select-focused:not(.", "-select-disabled){& > .", "-select-selector{box-shadow:none;border:1px solid ", ";}}&.", "-select-open{& > .", "-select-selector{display:flex;box-shadow:none;border:1px solid ", ";.arrow-up-icon{display:initial;color:", ";}.arrow-down-icon{display:none;}}}&.", "-select-open{& > .", "-select-selector{box-shadow:none;.", "-select-selection-item{.value{opacity:", ";}}}.", "-select-selection-search{display:flex;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;.", "-select-selection-search-input{height:auto;}}}&.", "-select-lg{.", "-select-selector{height:40px;}}& .", "-select-selector{border:1px solid ", ";border-radius:8px;padding:7px 16px;height:42px;display:flex;justify-content:center;align-items:center;p{display:inline;}.", "-select-selector__placeholder{height:24px;color:", ";font-size:14px;width:100%;}.", "-select-selection-search{display:flex;.", "-select-selection-search-input{height:auto;}}}.", "-select-selector__rendered{line-height:20px;margin:0;display:flex;align-items:center;}& .", "-select-selection-item{display:flex;flex-grow:1;padding-right:0;opacity:1 !important;.description{display:", ";}.check-icon{display:none;}.arrow-up-icon{display:none;}}& .", "-select-arrow{color:", ";padding:0px 16px;display:flex;justify-content:center;align-items:center;}.", "-select-dropdown-menu-item-disabled{background-color:red;}.", "-select-selection__clear{right:14px;font-size:20px;width:20px;height:20px;line-height:20px;top:15px;color:", ";}&:not(.", "-select-disabled):hover .", "-select-selector{border-color:", ";background:", ";}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, antdCssPrefix, antdCssPrefix, showSelectedItemDuringDropDown ? 1 : 0, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, ({
    hasError,
    theme
  }) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, hidedescriptiononselecteditem ? 'none' : 'inherit', antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray600'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray300'), ({
    theme
  }) => theme.getColor('gray100'));
});
const Select = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      options = [],
      value,
      suffixIcon = jsx(SmallChevronDown, {
        size: 18
      }),
      onChange,
      onSearch,
      footer,
      selectItemDataTestIdPrefix,
      hasError
    } = props,
    restProps = __rest(props, ["options", "value", "suffixIcon", "onChange", "onSearch", "footer", "selectItemDataTestIdPrefix", "hasError"]);
  const [ts] = useState(Date.now());
  // NOTE: hasError is not a valid prop for AntdSelect, so we need to remove it from the rest of the props
  // Otherwise we will see a warning in the console like:
  // "Warning: React does not recognize the `hasError` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `haserror` instead. If you accidentally passed it from a parent component, remove it from the DOM element."
  return jsxs(Fragment, {
    children: [jsx(GlobalStyle$5, {}), jsxs(StyledSelect, Object.assign({
      ref: ref
    }, value != null ? {
      value
    } : {
      value: undefined
    }, {
      onSearch: onSearch,
      dropdownClassName: "new-select-antd",
      onChange: onChange,
      suffixIcon: suffixIcon
    }, restProps, {
      children: [options === null || options === void 0 ? void 0 : options.map(opt => {
        if (opt.label && opt.options) {
          // groupped options
          return jsx(_Select.OptGroup, Object.assign({
            label: opt.label,
            title: opt.title
          }, {
            children: opt.options.map(o => {
              // normal options
              const {
                render
              } = o;
              const hasTopDivider = o.divider;
              const rowStyle = {
                borderTop: `1px solid ${getColor('gray300')}`
              };
              return jsx(_Select.Option, Object.assign({
                value: o.value,
                title: o.title,
                disabled: !!o.disabled,
                style: hasTopDivider ? rowStyle : {},
                "data-testid": `${selectItemDataTestIdPrefix}-${opt.value}`
              }, {
                children: jsxs("div", Object.assign({
                  style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: 'auto'
                  }
                }, {
                  children: [jsx("span", Object.assign({
                    style: {
                      minWidth: 0,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }
                  }, {
                    children: render ? render(o) : jsxs(FlexBox, Object.assign({
                      align: "center"
                    }, {
                      children: [o.prefixIcon && jsx("span", Object.assign({
                        style: {
                          marginRight: '16px'
                        }
                      }, {
                        children: o.prefixIcon
                      })), jsxs(FlexBox, Object.assign({
                        column: true
                      }, {
                        children: [jsx(Typography, Object.assign({
                          className: "value"
                        }, {
                          children: o.title
                        })), jsx(Typography, Object.assign({
                          className: "value description",
                          color: o.disabled ? 'gray400' : 'gray600'
                        }, {
                          children: o.description
                        })), o.descriptionNode]
                      }))]
                    }))
                  })), jsx("span", Object.assign({
                    className: "check-icon",
                    style: {
                      height: 24,
                      flex: 0,
                      flexBasis: 24
                    }
                  }, {
                    children: value === o.value ? jsx(Checkmark, {}) : null
                  }))]
                }))
              }), o.key || o.value);
            })
          }), opt.key || opt.label);
        } else {
          // normal options
          const {
            render
          } = opt;
          const hasTopDivider = opt.divider;
          const rowStyle = {
            borderTop: `1px solid ${getColor('gray300')}`
          };
          return jsx(_Select.Option, Object.assign({
            value: opt.value,
            title: opt.title,
            disabled: !!opt.disabled,
            style: hasTopDivider ? rowStyle : {},
            "data-testid": `${selectItemDataTestIdPrefix}-${opt.value}`
          }, {
            children: jsxs("div", Object.assign({
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: 'auto'
              }
            }, {
              children: [jsx("span", Object.assign({
                style: {
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }
              }, {
                children: render ? render(opt) : jsxs(FlexBox, Object.assign({
                  align: "center"
                }, {
                  children: [opt.prefixIcon && jsx("span", Object.assign({
                    style: {
                      marginRight: '16px'
                    }
                  }, {
                    children: opt.prefixIcon
                  })), jsxs(FlexBox, Object.assign({
                    column: true
                  }, {
                    children: [jsx(Typography, Object.assign({
                      className: "value",
                      variant: "default"
                    }, {
                      children: opt.title
                    })), jsx(Typography, Object.assign({
                      fontWeight: 400,
                      className: "value description",
                      color: opt.disabled ? 'gray400' : 'gray600'
                    }, {
                      children: opt.description
                    })), opt.descriptionNode]
                  }))]
                }))
              })), jsx("span", Object.assign({
                className: "check-icon",
                style: {
                  height: 24,
                  flex: 0,
                  flexBasis: 24
                }
              }, {
                children: value === opt.value ? jsx(Checkmark, {
                  color: colors.iconDefault
                }) : null
              }))]
            }))
          }), opt.key || opt.value);
        }
      }), footer && jsx("div", Object.assign({
        style: {
          borderTop: `1px solid ${getColor('gray300')}`
        }
      }, {
        children: footer
      }))]
    }), ts)]
  });
});

const Row = /*#__PURE__*/styled.div.withConfig({
  displayName: "container__Row",
  componentId: "sc-pfgca8-0"
})([""]);
const Container$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-pfgca8-1"
})(["display:flex;flex-direction:column;& > ", "{display:flex;& ~ ", "{margin-top:20px;}}"], Row, Row);

const Examples = props => {
  const [value, setValue] = useState('value1');
  const [gouppedExampleValue, setGouppedExampleValue] = useState('');
  return jsxs(Container$2, {
    children: [jsx(Row, {
      children: jsx(Typography, Object.assign({
        variant: "h3"
      }, {
        children: "Select v2 examples"
      }))
    }), jsx(Row, {
      children: jsx(Select, {
        value: value,
        onChange: val => setValue(val),
        options: [{
          value: 'value1',
          title: 'value1'
        }, {
          value: 'value2',
          title: 'value2'
        }, {
          value: 'value3',
          title: 'value3'
        }, {
          value: 'value4',
          title: 'value4'
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, Object.assign({
        variant: "h3"
      }, {
        children: "With descriptions in options, but hide the desc in selected item"
      }))
    }), jsx(Row, {
      children: jsx(Select, {
        value: value,
        allowClear: true,
        showSearch: true,
        hidedescriptiononselecteditem: true,
        onChange: val => setValue(val),
        options: [{
          value: 'value1',
          title: 'value1',
          description: 'description1'
        }, {
          value: 'value2',
          title: 'value2',
          description: 'description2'
        }, {
          value: 'value3',
          title: 'value3',
          description: 'description3'
        }, {
          value: 'value4',
          title: 'value4'
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, Object.assign({
        variant: "h3"
      }, {
        children: "With descriptions in options, and show the desc in selected item"
      }))
    }), jsx(Row, {
      children: jsx(Select, {
        value: value,
        allowClear: true,
        showSearch: true,
        onChange: val => setValue(val),
        options: [{
          value: 'value1',
          title: 'value1',
          description: 'description1'
        }, {
          value: 'value2',
          title: 'value2',
          description: 'description2'
        }, {
          value: 'value3',
          title: 'value3',
          description: 'description3'
        }, {
          value: 'value4',
          title: 'value4'
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, Object.assign({
        variant: "h3"
      }, {
        children: "Option group example"
      }))
    }), jsx(Row, {
      children: jsx(Select, {
        value: gouppedExampleValue,
        onChange: val => setGouppedExampleValue(val),
        showSearch: true,
        options: [{
          label: 'Designer',
          options: [{
            value: 'phil',
            title: 'Phil'
          }, {
            value: 'nash',
            title: 'Nash'
          }],
          value: ''
        }, {
          label: 'Engineer',
          options: [{
            value: 'demo',
            title: 'Demo'
          }, {
            value: 'david',
            title: 'David'
          }],
          value: ''
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, Object.assign({
        variant: "h3"
      }, {
        children: "With footer"
      }))
    }), jsx(Row, {
      children: jsx(Select, {
        value: gouppedExampleValue,
        onChange: val => setGouppedExampleValue(val),
        footer: jsx("div", {
          children: "Footer content"
        }),
        options: [{
          label: 'Designer',
          options: [{
            value: 'phil',
            title: 'Phil'
          }, {
            value: 'nash',
            title: 'Nash'
          }],
          value: ''
        }, {
          label: 'Engineer',
          options: [{
            value: 'demo',
            title: 'Demo'
          }, {
            value: 'david',
            title: 'David'
          }],
          value: ''
        }],
        style: {
          width: '200px'
        }
      })
    })]
  });
};

const IndicatorWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "indicator__IndicatorWrapper",
  componentId: "sc-dtg5s3-0"
})(["border-radius:50%;height:8px;width:8px;background-color:", ";"], ({
  variant,
  theme
}) => variant === 'warning' ? theme.getColor('gold600') : variant === 'success' ? theme.getColor('green500') : theme.getColor('gray400'));
const Indicator = props => {
  const {
    style
  } = props;
  return jsx(IndicatorWrapper, Object.assign({}, props, {
    style: style
  }));
};

const antdInputStyles$2 = /*#__PURE__*/css(["border-radius:8px;padding:10px 16px 10px 16px !important;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;&:hover,&:focus{box-shadow:none;border-color:", ";}&::placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}"], props => props.theme.colors.gray800, props => props.theme.colors.gray600, props => props.theme.colors.gray600, props => props.theme.colors.gray600);
const Input = /*#__PURE__*/styled(_Input).withConfig({
  displayName: "input__Input",
  componentId: "sc-18y16x2-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-input{height:40px;", "}"], antdCssPrefix, antdInputStyles$2);
});
const SearchInput = /*#__PURE__*/styled(Input.Search).attrs(props => ({
  suffix: jsx(MagnifyingGlass, {
    style: {
      color: colors$1.gray800,
      width: '16px',
      height: '16px',
      cursor: 'pointer'
    },
    "data-testid": "search-icon"
  })
})).withConfig({
  displayName: "input__SearchInput",
  componentId: "sc-18y16x2-1"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["width:240px;height:40px;& .", "-input-affix-wrapper{padding:0 11px 0 0;border-radius:8px !important;height:40px;}& .", "-input-affix-wrapper + .", "-input-group-addon{display:none;}.", "-input-suffix{right:18px;}& .", "-input-affix-wrapper:not(.", "-input-affix-wrapper-disabled):hover{border-color:", ";}& .", "-input-affix-wrapper:focus,.", "-input-affix-wrapper-focused{box-shadow:none;border-color:", ";}& .", "-input{", "}& .", "icon-close-circle > svg{color:", ";height:16px;width:16px;margin:0 4px;}& .", "icon-close-circle:hover{background-color:", ";border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdInputStyles$2, antdCssPrefix, props.theme.colors.gray500, antdCssPrefix, props.theme.colors.gray200);
});

const clsPrefix = 'er-tel-input';
const GlobalStyle$4 = /*#__PURE__*/createGlobalStyle(props => {
  return css([".", " .ant-input:focus,.", " .ant-input-focused{box-shadow:none;}.", " .intl-tel-input{width:100%;input,input[type='text'],input[type='tel']{&:hover,&:focus{border-color:", " !important;}border:1px solid ", " !important;outline:none;border-radius:8px !important;padding:10px 16px 10px 52px !important;width:100%;}}"], clsPrefix, clsPrefix, clsPrefix, props.hasError ? getColor('red500') : getColor('gray800'), props.hasError ? getColor('red500') : getColor('gray400'));
});
const StyleWrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "tel-input__StyleWrapper",
  componentId: "sc-mwtdcv-0"
})(["display:flex;width:100%;"]);
const TelInput = props => {
  const {
    hasError
  } = props;
  return jsxs(StyleWrapper$2, Object.assign({
    className: clsPrefix
  }, {
    children: [jsx(GlobalStyle$4, {
      hasError: hasError
    }), jsx(IntlTelInput, Object.assign({
      style: {
        borderColor: hasError ? getColor('red500') : ''
      }
    }, props))]
  }));
};

const DatePickerDayJs = generatePicker(dayjsGenerateConfig);
const {
  RangePicker: RangePickerAntd4
} = DatePickerDayJs;
const prefix = 'ant4';
const RangePicker = /*#__PURE__*/styled(RangePickerAntd4).withConfig({
  displayName: "date-picker__RangePicker",
  componentId: "sc-hfgyji-0"
})(["&.", "-picker{padding:", ";border:1px solid ", "!important;border-radius:8px;&:hover,&.", "-picker-focused{border:1px solid ", " !important;box-shadow:none;}.", "-picker-input,.", "-picker,.", "-select-single .", "-select-selector{height:32px;font-size:14px;border-radius:8px;width:100%;}}"], prefix, props => props.compact ? '1px 11px 1px' : 'init', ({
  hasError,
  theme
}) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), prefix, ({
  hasError,
  theme
}) => hasError ? theme.getColor('red500') : theme.getColor('gray800'), prefix, prefix, prefix, prefix);
const DatePicker = /*#__PURE__*/styled(DatePickerDayJs).withConfig({
  displayName: "date-picker__DatePicker",
  componentId: "sc-hfgyji-1"
})(["&.", "-picker{border:1px solid ", "!important;border-radius:8px;&:hover,&.", "-picker-focused{border:1px solid ", " !important;box-shadow:none;}.", "-picker-input,.", "-picker,.", "-select-single .", "-select-selector{height:32px;font-size:14px;border-radius:8px;width:100%;}}"], prefix, ({
  theme,
  hasError
}) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), prefix, ({
  theme,
  hasError
}) => hasError ? theme.getColor('red500') : theme.getColor('gray800'), prefix, prefix, prefix, prefix);
DatePicker.defaultProps = {
  suffixIcon: jsx(Calendar, {})
};

const StyleWrapper$1 = /*#__PURE__*/styled(Input.TextArea).withConfig({
  displayName: "text-area__StyleWrapper",
  componentId: "sc-qg20zu-0"
})(({
  theme,
  disabled
}) => css(["&.ant4-input{border-radius:8px;", "}"], !disabled && `&:hover,
    &:focus {
      border-color: ${theme.colors.gray800};
      box-shadow: none;
    }`));
const TextArea$1 = StyleWrapper$1;

const SSNInput = /*#__PURE__*/forwardRef((props, ref) => {
  return jsx(Input, Object.assign({}, props, {
    ref: ref
  }));
});

const blue = colors.blue500;
const green = colors.green500;
const sizeSelector = ({
  size
}) => size;
const Style$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "elevator-icon__Style",
  componentId: "sc-1eyyod9-0"
})(["height:", ";width:", ";border-radius:50%;display:inline-flex;flex-shrink:0;justify-content:center;align-items:center;border:1px solid ", ";background-color:white;color:", ";p{color:", ";}&.active{background-color:", ";color:white;p{color:white;}}&.completed{border:none;background-color:", ";color:white;}"], sizeSelector, sizeSelector, blue, blue, blue, blue, green);
const ElevatorIcon = ({
  active: _active = false,
  completed: _completed = false,
  children,
  className,
  size: _size = '30px'
}) => {
  return jsx(Style$1, Object.assign({
    className: classNames(className, {
      active: _active,
      completed: _completed
    }),
    size: _size
  }, {
    children: children
  }));
};

const Style = /*#__PURE__*/styled.div.withConfig({
  displayName: "elevator-item__Style",
  componentId: "sc-1j2xcw2-0"
})(["display:flex;gap:10px;align-items:center;padding:10px 16px;border-radius:8px;&.active{background-color:", ";}&.clickable{cursor:pointer;}&.disabled{cursor:not-allowed;}&:hover{background-color:", ";}"], colors.gray100, colors.gray100);
function ElevatorStep({
  initialStepIndex,
  title,
  subtitle,
  currentStepIndex,
  onClick,
  clickable = false,
  disabled = false,
  completed = currentStepIndex > initialStepIndex,
  active = currentStepIndex === initialStepIndex,
  className,
  icon
}) {
  const defaultIcon = jsx(ElevatorIcon, Object.assign({
    className: classNames({
      active,
      completed
    })
  }, {
    children: completed ? jsx(CheckOutlined, {}) : jsx(Text, Object.assign({
      variant: "bodyDefault"
    }, {
      children: initialStepIndex + 1
    }))
  }));
  const handleOnClick = () => {
    if (clickable) {
      onClick === null || onClick === void 0 ? void 0 : onClick(initialStepIndex);
    }
  };
  return jsxs(Style, Object.assign({
    className: classNames(className, {
      active,
      clickable,
      disabled
    }),
    onClick: handleOnClick
  }, {
    children: [icon || defaultIcon, jsxs("div", Object.assign({
      style: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, {
      children: [jsx(Text, Object.assign({
        variant: "bodyDefault",
        fontWeight: active ? 'semibold' : 'normal',
        className: "title"
      }, {
        children: title
      })), subtitle && jsx(Text, Object.assign({
        variant: "bodyDefault",
        fontSize: "12px",
        className: "description",
        color: active ? 'blue500' : 'gray600'
      }, {
        children: subtitle
      }))]
    }))]
  }));
}

function Elevator({
  className,
  steps = [],
  currentStepIndex = 0,
  onClick = noop
}) {
  return jsx("div", Object.assign({
    className: className
  }, {
    children: steps.map((_a, i) => {
      var {
          key
        } = _a,
        rest = __rest(_a, ["key"]);
      return jsx(ElevatorStep, Object.assign({}, rest, {
        initialStepIndex: i,
        currentStepIndex: currentStepIndex,
        onClick: onClick
      }), key);
    })
  }));
}

function ElevatorLayout({
  mainContent,
  sideContent,
  style,
  className
}) {
  if (!mainContent) {
    return null;
  }
  return jsx("div", Object.assign({
    style: style,
    className: className
  }, {
    children: sideContent ? jsxs(_Row, Object.assign({
      justify: "center"
    }, {
      children: [jsx(_Col, Object.assign({
        span: 24,
        md: 6
      }, {
        children: sideContent
      })), jsx(_Col, Object.assign({
        span: 24,
        md: {
          span: 17,
          offset: 1
        }
      }, {
        children: mainContent
      }))]
    })) : mainContent
  }));
}

/**
 * Breakpoints are referenced from:
 * https://tailwindcss.com/docs/responsive-design
 */
const maxWidthMixin = /*#__PURE__*/css(["@media (min-width:640px){max-width:640px;}@media (min-width:768px){max-width:768px;}@media (min-width:1024px){max-width:1024px;}@media (min-width:1280px){max-width:1280px;}@media (min-width:1536px){max-width:1536px;}"]);
const Container$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-7ytqya-0"
})(({
  centered
}) => {
  return css(["width:100%;height:100%;", " ", ""], centered && css(["margin-left:auto;margin-right:auto;"]), maxWidthMixin);
});

const OverrideStyles = /*#__PURE__*/createGlobalStyle([".ws-sliding-pane{.ant4-drawer-content{border-radius:20px 20px 0 0;}.ant4-drawer-title{font-family:'Plus Jakarta Sans','Segoe UI',Roboto,Helvetica Neue,sans-serif;font-size:20px;font-weight:700;}.ant4-drawer-header{display:", ";}}"], props => props.showHeader ? 'flex' : 'none');
const SlidingPane = props => {
  const {
      title,
      actions = [],
      isOpen,
      onClose,
      children,
      okText,
      onOk,
      okStyle = {},
      cancelText,
      onCancel,
      okDisabled,
      cancelDisabled,
      okLoading,
      headerStyle,
      headerContainerStyle,
      bodyStyle,
      containerStyle = {},
      extraActions,
      cancelStyle = {},
      okDropdownItems = []
    } = props,
    otherProps = __rest(props, ["title", "actions", "isOpen", "onClose", "children", "okText", "onOk", "okStyle", "cancelText", "onCancel", "okDisabled", "cancelDisabled", "okLoading", "headerStyle", "headerContainerStyle", "bodyStyle", "containerStyle", "extraActions", "cancelStyle", "okDropdownItems"]);
  const renderOkButton = () => {
    if (okDropdownItems.length > 0) {
      return jsxs(ButtonNew.Group, {
        children: [jsx(ButtonNew, Object.assign({
          type: "primary",
          onClick: onOk,
          disabled: okDisabled,
          loading: okLoading,
          style: okStyle
        }, {
          children: okText || 'Continue'
        })), jsx(Dropdown, Object.assign({
          placement: "bottomRight",
          trigger: ['click'],
          menu: {
            items: okDropdownItems
          }
        }, {
          children: jsx(ButtonNew, {
            type: "primary",
            loading: okLoading,
            icon: "ChevronDown",
            paddingLeft: "8px",
            paddingRight: "8px"
          })
        }))]
      });
    }
    return jsx(ButtonNew, Object.assign({
      type: "primary",
      onClick: onOk,
      disabled: okDisabled,
      loading: okLoading,
      style: okStyle
    }, {
      children: okText || 'Continue'
    }));
  };
  const renderExtra = () => {
    return actions.length > 0 ? jsxs(_Space, Object.assign({
      size: 12
    }, {
      children: [extraActions ? jsx(ButtonNew, Object.assign({
        type: "secondary",
        onClick: onCancel,
        disabled: cancelDisabled,
        style: cancelStyle
      }, {
        children: cancelText || 'Cancel'
      })) : null, actions.map(action => {
        const {
            type
          } = action,
          rest = __rest(action, ["type"]);
        const isWarningBtn = type === 'danger';
        return isWarningBtn ? jsx(ButtonNew, Object.assign({
          backgroundColor: "red500",
          hoverBgColor: "red600",
          color: "white"
        }, rest, {
          children: action.label
        }), action.label) : jsx(ButtonNew, Object.assign({}, rest, {
          children: action.label
        }), action.label);
      }), extraActions ? renderOkButton() : null]
    })) : jsxs(_Space, Object.assign({
      size: 12
    }, {
      children: [jsx(ButtonNew, Object.assign({
        type: "secondary",
        onClick: onCancel,
        disabled: cancelDisabled
      }, {
        children: cancelText || 'Cancel'
      })), renderOkButton()]
    }));
  };
  const header = jsx(Container$1, Object.assign({
    centered: true,
    style: headerContainerStyle
  }, {
    children: jsxs(_Space, Object.assign({
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      size: 20
    }, {
      children: [title, renderExtra()]
    }))
  }));
  const contentPadding = {
    padding: '20px 40px'
  };
  return jsxs(Fragment, {
    children: [jsx(OverrideStyles, Object.assign({
      showHeader: true
    }, props, {
      children: undefined
    })), jsx(_Drawer, Object.assign({
      className: "ws-sliding-pane",
      title: header,
      placement: "bottom",
      width: "100vw",
      height: "98%",
      onClose: onClose,
      visible: isOpen,
      closable: false,
      destroyOnClose: true,
      headerStyle: Object.assign(Object.assign(Object.assign({}, contentPadding), {
        gap: 20
      }), headerStyle),
      bodyStyle: Object.assign(Object.assign({
        background: getColor('#F3F5F9')
      }, contentPadding), bodyStyle)
    }, otherProps, {
      children: jsx(Container$1, Object.assign({
        centered: true,
        style: containerStyle
      }, {
        children: children
      }))
    }))]
  });
};

const GlobalStyle$3 = /*#__PURE__*/createGlobalStyle(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css([".", "-select-dropdown{border-radius:8px;}.", "-select-item-option-selected{background-color:", " !important;}"], antdCssPrefix, antdCssPrefix, getColor('gray100'));
});
const antdInputStyles$1 = /*#__PURE__*/css(["border-radius:8px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;border-color:", " !important;box-shadow:none;&:hover,&:focus{box-shadow:none;border-color:", " !important;}&::placeholder{color:", ";}&:-ms-input-number-placeholder{color:", ";}&::-ms-input-number-placeholder{color:", ";}"], props => props.hasError ? getColor('red500') : getColor('gray400'), props => props.hasError ? getColor('red500') : getColor('gray800'), getColor('gray600'), getColor('gray600'), getColor('gray600'));
const NumInput = /*#__PURE__*/styled(_InputNumber).withConfig({
  displayName: "number-input__NumInput",
  componentId: "sc-dwxkit-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-input-number{", "}.", "-input-number-input{height:40px;padding:10px 16px 10px 16px !important;box-shadow:none;}.", "-input-number-group-addon{border-radius:8px 0 0 8px;border-color:", " !important;}.", "-input-number-handler-wrap{border-radius:8px;svg{fill:", ";}}.", "-select-selector{border:0 !important;height:100%;width:100px;box-shadow:none !important;}.", "-select-selection-item{color:", ";}"], antdCssPrefix, antdInputStyles$1, antdCssPrefix, antdCssPrefix, props => props.hasError ? getColor('red500') : getColor('gray400'), antdCssPrefix, getColor('gray600'), antdCssPrefix, antdCssPrefix, getColor('gray600'));
});
const NumberInput = props => {
  return jsxs(Fragment, {
    children: [jsx(GlobalStyle$3, {}), jsx(NumInput, Object.assign({}, props))]
  });
};

const {
  Dragger
} = _Upload;
const UploadWrapper = /*#__PURE__*/styled('div').withConfig({
  displayName: "upload__UploadWrapper",
  componentId: "sc-h6pbpw-0"
})(() => {
  const antdPrefix = globalConfig().getPrefixCls();
  return css(["width:100%;.", "-upload.ant4-upload-drag{background:white;height:120px;border:1px dashed ", ";&:hover{border:1px dashed ", ";}}"], antdPrefix, ({
    theme
  }) => theme.getColor('gray400'), ({
    theme
  }) => theme.getColor('gray600'));
});
const Upload = props => {
  const {
      draggable,
      onUpload,
      onSuccess,
      onError,
      title,
      description,
      content
    } = props,
    otherProps = __rest(props, ["draggable", "onUpload", "onSuccess", "onError", "title", "description", "content"]);
  const defaultProps = {
    multiple: true,
    onChange(info) {
      const {
        status
      } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
        onUpload && onUpload(info);
      }
      if (status === 'done') {
        _message.success(`${info.file.name} upload success.`);
        onSuccess && onSuccess(info);
      } else if (status === 'error') {
        _message.error(`${info.file.name} upload failed.`);
        onError && onError(info);
      }
    }
  };
  return jsx(UploadWrapper, {
    children: draggable ? jsx(Dragger, Object.assign({}, defaultProps, otherProps, props, {
      children: content || jsxs(Fragment, {
        children: [jsx(Typography, Object.assign({
          color: "gray800",
          fontWeight: 600
        }, {
          children: title || 'Select file'
        })), jsx(Typography, {
          children: description || 'or drop your files here'
        })]
      })
    })) : jsx(_Upload, Object.assign({}, defaultProps, otherProps, props, {
      children: jsx(ButtonNew, {
        children: "Upload"
      })
    }))
  });
};

var SizeEnum;
(function (SizeEnum) {
  SizeEnum["h1"] = "36px";
  SizeEnum["h2"] = "30px";
  SizeEnum["h3"] = "24px";
  SizeEnum["h4"] = "18px";
  SizeEnum["h5"] = "16px";
  SizeEnum["h6"] = "14px";
  SizeEnum["h7"] = "12px";
})(SizeEnum || (SizeEnum = {}));
const sizeMap = {
  h1: SizeEnum.h1,
  h2: SizeEnum.h2,
  h3: SizeEnum.h3,
  h4: SizeEnum.h4,
  h5: SizeEnum.h5,
  h6: SizeEnum.h6,
  h7: SizeEnum.h7
};
const HeadingWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "heading__HeadingWrapper",
  componentId: "sc-1y0rtpl-0"
})(["font-size:", ";font-weight:", ";color:", ";"], props => props.size, props => props.isMedium ? 600 : 700, props => props.color);
const Heading = props => {
  const {
    type,
    children,
    style = {},
    weight = 'bold'
  } = props;
  return jsx(HeadingWrapper, Object.assign({
    style: style,
    size: sizeMap[type || 'h5'],
    isMedium: weight === 'medium',
    color: props.type === 'h7' ? getColor('gray600') : getColor('gray800')
  }, {
    children: children
  }));
};

var DESCRIPTORS$1 = descriptors;
var fails$5 = fails$d;
var has = has$b;

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

var arrayMethodUsesToLength$2 = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails$5(function () {
    if (ACCESSORS && !DESCRIPTORS$1) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};

var $$7 = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables = addToUnscopables$2;
var arrayMethodUsesToLength$1 = arrayMethodUsesToLength$2;

var USES_TO_LENGTH$1 = arrayMethodUsesToLength$1('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
$$7({ target: 'Array', proto: true, forced: !USES_TO_LENGTH$1 }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject$2 = isObject$9;
var classof$6 = classofRaw$1;
var wellKnownSymbol$a = wellKnownSymbol$g;

var MATCH$1 = wellKnownSymbol$a('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$6(it) == 'RegExp');
};

var isRegExp = isRegexp;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$9 = wellKnownSymbol$g;

var MATCH = wellKnownSymbol$9('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

var $$6 = _export;
var notARegExp = notARegexp;
var requireObjectCoercible$3 = requireObjectCoercible$6;
var correctIsRegExpLogic = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
$$6({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible$3(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

const styledTable = () => styled(_a => {
  var {
      className,
      rowBorder = true
    } = _a,
    otherProps = __rest(_a, ["className", "rowBorder"]);
  const isWindows = navigator.userAgent.includes('Win');
  return jsx(_Table, Object.assign({
    className: classNames(className, {
      'os-win': isWindows
    })
  }, otherProps));
}).withConfig({
  displayName: "table__styledTable",
  componentId: "sc-1gt3wr1-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    rowBorder = true
  } = props;
  return css(["font-family:'Plus Jakarta Sans',sans-serif;& .", "-checkbox-wrapper{justify-content:flex-start;align-items:center;}& .", "-checkbox{top:unset;}& .", "-checkbox-inner{width:18px;height:18px;border-radius:4px;&:after{left:4px;top:7px;width:5px;height:9px;}}& .", "-checkbox-indeterminate .", "-checkbox-inner:after{left:8px;top:8px;width:10px;height:2px;background-color:", ";}& .", "-checkbox-checked .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}.", "-checkbox-wrapper:hover .", "-checkbox-inner,& .", "-checkbox:hover .", "-checkbox-inner,& .", "-checkbox-input:focus + .", "-checkbox-inner{border-color:", ";}& .", "-checkbox-checked::after{border:unset;}&.os-win{.", "-table-fixed-header .", "-table-scroll .", "-table-header{padding-bottom:4px;background:#fff;}.", "-table-fixed-header .", "-table-scroll .", "-table-header::-webkit-scrollbar{background-color:transparent;}}& .", "-table-row-expand-icon{border:none;&.", "-table-row-collapsed:after{content:url('data:image/svg+xml; utf8, %3Csvg%20width%3D%2212%22%20height%3D%228%22%20viewBox%3D%220%200%2012%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M10.9999%201.17C10.8126%200.983753%2010.5591%200.879211%2010.2949%200.879211C10.0308%200.879211%209.77731%200.983753%209.58995%201.17L5.99995%204.71L2.45995%201.17C2.27259%200.983753%202.01913%200.879211%201.75495%200.879211C1.49076%200.879211%201.23731%200.983753%201.04995%201.17C0.95622%201.26297%200.881826%201.37357%200.831057%201.49543C0.780288%201.61729%200.75415%201.74799%200.75415%201.88C0.75415%202.01202%200.780288%202.14272%200.831057%202.26458C0.881826%202.38644%200.95622%202.49704%201.04995%202.59L5.28995%206.83C5.38291%206.92373%205.49351%206.99813%205.61537%207.04889C5.73723%207.09966%205.86794%207.1258%205.99995%207.1258C6.13196%207.1258%206.26267%207.09966%206.38453%207.04889C6.50638%206.99813%206.61699%206.92373%206.70995%206.83L10.9999%202.59C11.0937%202.49704%2011.1681%202.38644%2011.2188%202.26458C11.2696%202.14272%2011.2957%202.01202%2011.2957%201.88C11.2957%201.74799%2011.2696%201.61729%2011.2188%201.49543C11.1681%201.37357%2011.0937%201.26297%2010.9999%201.17Z%22%20fill%3D%22%2371717A%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E');transform:rotate(270deg);display:inline-block;height:16px;width:16px;}&.", "-table-row-expanded:after{content:url('data:image/svg+xml; utf8, %3Csvg%20width%3D%2212%22%20height%3D%228%22%20viewBox%3D%220%200%2012%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M10.9999%201.17C10.8126%200.983753%2010.5591%200.879211%2010.2949%200.879211C10.0308%200.879211%209.77731%200.983753%209.58995%201.17L5.99995%204.71L2.45995%201.17C2.27259%200.983753%202.01913%200.879211%201.75495%200.879211C1.49076%200.879211%201.23731%200.983753%201.04995%201.17C0.95622%201.26297%200.881826%201.37357%200.831057%201.49543C0.780288%201.61729%200.75415%201.74799%200.75415%201.88C0.75415%202.01202%200.780288%202.14272%200.831057%202.26458C0.881826%202.38644%200.95622%202.49704%201.04995%202.59L5.28995%206.83C5.38291%206.92373%205.49351%206.99813%205.61537%207.04889C5.73723%207.09966%205.86794%207.1258%205.99995%207.1258C6.13196%207.1258%206.26267%207.09966%206.38453%207.04889C6.50638%206.99813%206.61699%206.92373%206.70995%206.83L10.9999%202.59C11.0937%202.49704%2011.1681%202.38644%2011.2188%202.26458C11.2696%202.14272%2011.2957%202.01202%2011.2957%201.88C11.2957%201.74799%2011.2696%201.61729%2011.2188%201.49543C11.1681%201.37357%2011.0937%201.26297%2010.9999%201.17Z%22%20fill%3D%22%2371717A%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E');display:inline-block;height:16px;width:16px;}}& .", "-table-thead{& > tr > th{font-weight:600;font-size:12px;line-height:17px;color:", ";", ";&::before{display:none;}}th{padding:8px 10px;background:#fff;", ";", ";}.col-hidden{padding:8px 2px 8px 10px;> span{display:flex;align-items:center;}}}& tbody.", "-table-tbody{font-weight:400;font-size:14px;line-height:20px;& .", "-table-row{&:hover{td{background-color:", ";}}td{padding:20px 10px;", ";color:", ";}&.", "-table-row-level-0{.placeholder{width:12px;flex-shrink:0;}}&.", "-table-row-level-1,&.", "-table-row-level-2{.placeholder{width:58px;flex-shrink:0;}}.col-hidden{visibility:hidden;width:0;padding:0;.", "-table-row-expand-icon{display:none;}.", "-table-row-indent{display:none;}}}}& .", "-table-placeholder{border-bottom:none;}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.white, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, !rowBorder && 'border-bottom: unset', rowBorder && 'border-bottom: 1px solid #eceef0', rowBorder && 'border-top: 1px solid #eceef0', antdCssPrefix, antdCssPrefix, props.theme.colors.gray100, rowBorder ? 'border-bottom: 1px solid #eceef0' : 'border-bottom: unset', props.theme.colors.gray800, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix);
});
const Table = styledTable();
const FullWidthTable = /*#__PURE__*/styled(Table).withConfig({
  displayName: "table__FullWidthTable",
  componentId: "sc-1gt3wr1-1"
})(["width:100%;"]);
function createTable() {
  return styledTable();
}
function createFullWidthTable() {
  const TableComp = styledTable();
  return styled(TableComp).withConfig({
    displayName: "table",
    componentId: "sc-1gt3wr1-2"
  })(["width:100%;"]);
}

const CheckboxGroup = /*#__PURE__*/styled(Checkbox.Group).withConfig({
  displayName: "checkbox-group__CheckboxGroup",
  componentId: "sc-r89ma9-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    checkboxWrapperMargin
  } = props;
  return css(["& .", "-checkbox-wrapper{justify-content:flex-start;align-items:center;margin:", ";}& .", "-checkbox{top:unset;}& .", "-checkbox-inner{width:18px;height:18px;border-radius:4px;&:after{left:4px;top:7px;width:5px;height:9px;}}& .", "-checkbox-indeterminate .", "-checkbox-inner:after{left:8px;top:8px;width:10px;height:2px;background-color:", ";}& .", "-checkbox-checked .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}.", "-checkbox-wrapper:hover .", "-checkbox-inner,& .", "-checkbox:hover .", "-checkbox-inner,& .", "-checkbox-input:focus + .", "-checkbox-inner{border-color:", ";}& .", "-checkbox-checked::after{border:unset;}"], antdCssPrefix, checkboxWrapperMargin, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.white, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix);
});

const GlobalStyle$2 = /*#__PURE__*/createGlobalStyle([".ant4-tooltip-inner{border-radius:8px;padding:10px;background:", ";}"], ({
  theme
}) => theme.getColor('gray800'));
const Tooltip = props => {
  return jsxs(Fragment, {
    children: [jsx(GlobalStyle$2, {}), jsx(_Tooltip, Object.assign({}, props))]
  });
};

const Menu = /*#__PURE__*/styled(_Menu).withConfig({
  displayName: "menu__Menu",
  componentId: "sc-zir1c8-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-dropdown-menu{box-shadow:0px 4px 20px rgba(0,0,0,0.08);border-radius:8px;}.", "-dropdown-menu-item,.", "-dropdown-menu-submenu-title{padding:12px 16px;color:", ";&:hover{background:", ";}}.", "-dropdown-menu-item.ant4-dropdown-menu-item-danger{color:", ";}.", "-dropdown-menu-item-disabled{filter:opacity(0.3);&:hover{background:none;}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, props => props.theme.colors.gray800, props => props.theme.colors.gray100, antdCssPrefix, props => props.theme.colors.red500, antdCssPrefix);
});
Menu.Divider = _Menu.Divider;
Menu.SubMenu = _Menu.SubMenu;
Menu.Item = _Menu.Item;
Menu.ItemGroup = _Menu.ItemGroup;

const StyleWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ellipsis__StyleWrapper",
  componentId: "sc-761bg4-0"
})(["display:inline-block;width:", ";max-width:", ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"], props => props.width || 'auto', props => props.maxWidth || 'none');
const StyleWrapperMultiLine = /*#__PURE__*/styled.span.withConfig({
  displayName: "ellipsis__StyleWrapperMultiLine",
  componentId: "sc-761bg4-1"
})(["width:", ";max-width:", ";overflow:hidden;display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;"], props => props.width || 'auto', props => props.maxWidth || 'none', props => props.line || 1);
const Ellipsis = props => {
  const {
    children,
    line = 1,
    showTip = true,
    tipPlacement = 'bottom'
  } = props;
  return line === 1 ? showTip ? jsx(Tooltip, Object.assign({
    placement: tipPlacement,
    title: children
  }, {
    children: jsx(StyleWrapper, Object.assign({}, props, {
      children: children
    }))
  })) : jsx(StyleWrapper, Object.assign({}, props, {
    children: children
  })) : showTip ? jsx(Tooltip, Object.assign({
    placement: tipPlacement,
    title: children
  }, {
    children: jsx(StyleWrapperMultiLine, Object.assign({}, props, {
      children: children
    }))
  })) : jsx(StyleWrapperMultiLine, Object.assign({}, props, {
    children: children
  }));
};

const Notification = /*#__PURE__*/styled(_Alert).withConfig({
  displayName: "notification__Notification",
  componentId: "sc-1y0hs8d-0"
})(props => {
  return css(["background:", ";border:none;border-radius:8px;width:100%;&.ant4-alert-info .ant4-alert-icon{color:", ";}"], ({
    theme
  }) => theme.getColor('blue100'), ({
    theme
  }) => theme.getColor('gray800'));
});

var global$7 = global$k;

var nativePromiseConstructor = global$7.Promise;

var redefine$3 = redefine$6.exports;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$3(target, key, src[key], options);
  return target;
};

var getBuiltIn$3 = getBuiltIn$6;
var definePropertyModule = objectDefineProperty;
var wellKnownSymbol$8 = wellKnownSymbol$g;
var DESCRIPTORS = descriptors;

var SPECIES$3 = wellKnownSymbol$8('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var aFunction$6 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterate$3 = {exports: {}};

var wellKnownSymbol$7 = wellKnownSymbol$g;
var Iterators$1 = iterators;

var ITERATOR$2 = wellKnownSymbol$7('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$2] === it);
};

var aFunction$5 = aFunction$6;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$5(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var wellKnownSymbol$6 = wellKnownSymbol$g;

var TO_STRING_TAG$1 = wellKnownSymbol$6('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$5 = wellKnownSymbol$g;

var TO_STRING_TAG = wellKnownSymbol$5('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$5 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var classof$4 = classof$5;
var Iterators = iterators;
var wellKnownSymbol$4 = wellKnownSymbol$g;

var ITERATOR$1 = wellKnownSymbol$4('iterator');

var getIteratorMethod$1 = function (it) {
  if (it != undefined) return it[ITERATOR$1]
    || it['@@iterator']
    || Iterators[classof$4(it)];
};

var anObject$5 = anObject$b;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$5(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject$5(returnMethod.call(iterator));
    throw error;
  }
};

var anObject$4 = anObject$b;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var toLength$2 = toLength$4;
var bind$2 = functionBindContext;
var getIteratorMethod = getIteratorMethod$1;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate$2 = iterate$3.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind$2(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength$2(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject$4(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate$2.stop = function (result) {
  return new Result(true, result);
};

var wellKnownSymbol$3 = wellKnownSymbol$g;

var ITERATOR = wellKnownSymbol$3('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var anObject$3 = anObject$b;
var aFunction$4 = aFunction$6;
var wellKnownSymbol$2 = wellKnownSymbol$g;

var SPECIES$2 = wellKnownSymbol$2('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$3(O).constructor;
  var S;
  return C === undefined || (S = anObject$3(C)[SPECIES$2]) == undefined ? defaultConstructor : aFunction$4(S);
};

var getBuiltIn$2 = getBuiltIn$6;

var engineUserAgent = getBuiltIn$2('navigator', 'userAgent') || '';

var userAgent$1 = engineUserAgent;

var engineIsIos = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent$1);

var global$6 = global$k;
var fails$4 = fails$d;
var classof$3 = classofRaw$1;
var bind$1 = functionBindContext;
var html = html$2;
var createElement = documentCreateElement$1;
var IS_IOS$1 = engineIsIos;

var location = global$6.location;
var set = global$6.setImmediate;
var clear = global$6.clearImmediate;
var process$3 = global$6.process;
var MessageChannel = global$6.MessageChannel;
var Dispatch = global$6.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$6.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classof$3(process$3) == 'process') {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$1(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$6.addEventListener &&
    typeof postMessage == 'function' &&
    !global$6.importScripts &&
    !fails$4(post) &&
    location.protocol !== 'file:'
  ) {
    defer = post;
    global$6.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$5 = global$k;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var classof$2 = classofRaw$1;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var process$2 = global$5.process;
var Promise$1 = global$5.Promise;
var IS_NODE$1 = classof$2(process$2) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$5, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE$1) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !IS_IOS) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;
    notify$1 = function () {
      then.call(promise, flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$1 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global$5, flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aFunction$3 = aFunction$6;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$3(resolve);
  this.reject = aFunction$3(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$2 = anObject$b;
var isObject$1 = isObject$9;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$2 = function (C, x) {
  anObject$2(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$4 = global$k;

var hostReportErrors$1 = function (a, b) {
  var console = global$4.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$2 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$3 = global$k;
var userAgent = engineUserAgent;

var process$1 = global$3.process;
var versions = process$1 && process$1.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var $$5 = _export;
var global$2 = global$k;
var getBuiltIn$1 = getBuiltIn$6;
var NativePromise$1 = nativePromiseConstructor;
var redefine$2 = redefine$6.exports;
var redefineAll = redefineAll$1;
var setToStringTag = setToStringTag$3;
var setSpecies = setSpecies$1;
var isObject = isObject$9;
var aFunction$2 = aFunction$6;
var anInstance = anInstance$1;
var classof$1 = classofRaw$1;
var inspectSource = inspectSource$3;
var iterate$1 = iterate$3.exports;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor$1 = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve$1 = promiseResolve$2;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform$1 = perform$2;
var InternalStateModule = internalState;
var isForced = isForced_1;
var wellKnownSymbol$1 = wellKnownSymbol$g;
var V8_VERSION = engineV8Version;

var SPECIES$1 = wellKnownSymbol$1('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise$1;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var $fetch = getBuiltIn$1('fetch');
var newPromiseCapability = newPromiseCapabilityModule$1.f;
var newGenericPromiseCapability = newPromiseCapability;
var IS_NODE = classof$1(process) == 'process';
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$1 = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
  }
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$1] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED$1 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global$2['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task.call(global$2, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$1(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task.call(global$2, function () {
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction$2(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor$1(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapabilityModule$1.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof NativePromise$1 == 'function') {
    nativeThen = NativePromise$1.prototype.then;

    // wrap native Promise#then for native async functions
    redefine$2(NativePromise$1.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $$5({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input /* , init */) {
        return promiseResolve$1(PromiseConstructor, $fetch.apply(global$2, arguments));
      }
    });
  }
}

$$5({ global: true, wrap: true, forced: FORCED$1 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn$1(PROMISE);

// statics
$$5({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$$5({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});

$$5({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aFunction$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aFunction$2(C.resolve);
      iterate$1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$4 = _export;
var aFunction$1 = aFunction$6;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$2;
var iterate = iterate$3.exports;

// `Promise.allSettled` method
// https://github.com/tc39/proposal-promise-allSettled
$$4({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (e) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: e };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

function getFileNameWithoutExtension(fileName) {
  return fileName.split('.').slice(0, -1).join('.');
}

const spinAnimation$1 = /*#__PURE__*/keyframes(["100%{transform:rotate(360deg);}"]);
const AnimatedLoading$1 = /*#__PURE__*/styled(Loading).withConfig({
  displayName: "manual-upload__AnimatedLoading",
  componentId: "sc-1k30qk6-0"
})(["color:", ";animation:", " 2s linear infinite;"], ({
  theme
}) => theme.getColor('gray600'), spinAnimation$1);
const ManualUpload = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      url,
      style,
      fetcher,
      onUploaded,
      onFileListChange,
      payloadMapper,
      hideDocName,
      multiple = false
    } = props,
    otherProps = __rest(props, ["url", "style", "fetcher", "onUploaded", "onFileListChange", "payloadMapper", "hideDocName", "multiple"]);
  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const filePayloadList = useMemo(() => fileList.map(file => {
    const payload = {
      [(payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileField) || 'file']: file.originFileObj,
      [(payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileNameField) || 'file_name']: file.name
    };
    return {
      payload: serialize(payload),
      fileObj: file
    };
  }), [fileList, payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileField, payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileNameField]);
  const mergeUploadResWithFileList = useCallback(resultList => {
    const mergedList = fileList.map((fileObj, index) => {
      const currentResult = resultList[index];
      let status = '';
      switch (currentResult === null || currentResult === void 0 ? void 0 : currentResult.status) {
        case 'fulfilled':
          status = 'success';
          break;
        case 'rejected':
          status = 'error';
          break;
      }
      return Object.assign(Object.assign({}, fileObj), {
        status: status,
        value: currentResult === null || currentResult === void 0 ? void 0 : currentResult.value,
        reason: currentResult === null || currentResult === void 0 ? void 0 : currentResult.reason,
        response: currentResult === null || currentResult === void 0 ? void 0 : currentResult.value
      });
    });
    return mergedList;
  }, [fileList]);
  useImperativeHandle(ref, () => ({
    upload: () => {
      setIsUploading(true);
      Promise.allSettled(filePayloadList.map((filePayload, index) => {
        var _a, _b;
        if (filePayload.fileObj.status === 'success') {
          return Promise.resolve(filePayload.fileObj.value);
        }
        if (((_b = getFileNameWithoutExtension((_a = filePayload === null || filePayload === void 0 ? void 0 : filePayload.fileObj) === null || _a === void 0 ? void 0 : _a.name)) === null || _b === void 0 ? void 0 : _b.length) > 100) {
          return Promise.reject('file name can not be longer than 100 characters');
        }
        return fetcher.post(url, filePayload.payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      })).then(values => {
        const mergedList = mergeUploadResWithFileList(values);
        setFileList(mergedList);
        if (isFunction(onFileListChange)) {
          onFileListChange(mergedList);
        }
        const hasAllFileUploaded = mergedList.every(file => file.status === 'success');
        if (hasAllFileUploaded) {
          setFileList([]);
          if (isFunction(onFileListChange)) {
            onFileListChange([]);
          }
          _message.success('All files uploaded successfully');
        } else {
          _message.warn('Some files failed to upload');
        }
        setIsUploading(false);
        if (isFunction(onUploaded)) {
          onUploaded(values, hasAllFileUploaded);
        }
      });
    },
    getIsLoading: () => isUploading,
    getFileList: () => fileList
  }), [fetcher, fileList, filePayloadList, isUploading, mergeUploadResWithFileList, onFileListChange, onUploaded, url]);
  const fileColumns = [{
    title: 'Document name  (100 character limit)',
    dataIndex: 'name',
    key: 'name',
    render: (fileName, record) => {
      var _a, _b, _c;
      const fileExt = fileName.split('.').pop();
      const isSuccess = (record === null || record === void 0 ? void 0 : record.status) === 'success';
      const isError = (record === null || record === void 0 ? void 0 : record.status) === 'error';
      // const isUploading = record?.status === 'uploading';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const errorMessage = (_c = (_b = (_a = record === null || record === void 0 ? void 0 : record.reason) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message;
      const statusMsg = isSuccess ? 'File upload success' : isError ? `Upload error: ${errorMessage ? errorMessage : record.reason}` : '';
      return jsxs(_Space, Object.assign({
        direction: "vertical",
        style: {
          width: '100%'
        },
        size: 8
      }, {
        children: [jsx(Tooltip, Object.assign({
          placement: "top",
          title: statusMsg
        }, {
          children: jsxs("div", Object.assign({
            style: {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }
          }, {
            children: [isUploading && !isSuccess && jsx(AnimatedLoading$1, {
              style: {
                marginRight: 8
              }
            }), isError && jsx(Error$1, {
              color: "red500",
              style: {
                marginRight: 8
              }
            }), isSuccess && jsx(Checkmark, {
              color: "green500",
              style: {
                marginRight: 8
              }
            }), !isError && !isSuccess && !isUploading && jsx(Document, {
              color: "gray600",
              style: {
                marginRight: 8
              }
            }), jsx(Input, {
              "data-testid": `manual-upload-file-name-input-${record.uid}`,
              minLength: 1,
              maxLength: 100,
              disabled: isSuccess,
              style: {
                flex: 1,
                borderColor: isError ? getColor('red500') : getColor('gray400')
              },
              value: getFileNameWithoutExtension(fileName),
              onChange: e => {
                const fList = fileList.map(file => {
                  if (file.uid === record.uid) {
                    return Object.assign(Object.assign({}, file), {
                      name: `${e.target.value}.${fileExt}`
                    });
                  }
                  return file;
                });
                setFileList(fList);
                if (isFunction(onFileListChange)) {
                  onFileListChange(fList);
                }
              }
            }), jsxs("span", Object.assign({
              style: {
                marginRight: 30,
                color: getColor('gray600')
              }
            }, {
              children: [".", fileExt]
            })), jsx(Cross, {
              color: "gray600",
              style: {
                visibility: !isSuccess ? 'visible' : 'hidden'
              },
              onClick: () => {
                const fList = fileList.filter(file => file.uid !== record.uid);
                setFileList(fList);
                if (isFunction(onFileListChange)) {
                  onFileListChange(fList);
                }
              }
            })]
          }))
        })), isError && jsx("div", Object.assign({
          style: {
            marginLeft: 32
          }
        }, {
          children: statusMsg
        }))]
      }));
    }
  }];
  return jsxs(_Space, Object.assign({
    direction: "vertical",
    style: Object.assign({
      width: '100%'
    }, style),
    size: 0
  }, {
    children: [jsx(Upload, Object.assign({
      content: jsxs(Fragment, {
        children: [jsx(Typography, Object.assign({
          color: "gray600",
          fontWeight: 600
        }, {
          children: "Select files"
        })), jsx(Typography, {
          children: "or drop your files here"
        }), jsx(Typography, Object.assign({
          color: "gray400"
        }, {
          children: "Max file size: 10mb"
        }))]
      }),
      action: url,
      fileList: fileList,
      showUploadList: false,
      beforeUpload: () => false,
      multiple: multiple
    }, otherProps, {
      onChange: uploadInfo => {
        if (multiple) {
          setFileList(uploadInfo.fileList);
        } else {
          setFileList([uploadInfo.file]);
        }
        if (isFunction(onFileListChange)) {
          onFileListChange(uploadInfo.fileList);
        }
      }
    })), !hideDocName && fileList.length > 0 && jsx(FullWidthTable, {
      sticky: true,
      scroll: {
        y: 300
      },
      style: {
        marginTop: '20px'
      },
      dataSource: fileList,
      columns: fileColumns,
      pagination: false
    })]
  }));
});

const IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "country-region-selector__IconWrapper",
  componentId: "sc-n2zgw4-0"
})([""]);
const Wrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "country-region-selector__Wrapper",
  componentId: "sc-n2zgw4-1"
})(["position:relative;&::after{content:'';font-size:1rem;top:6px;right:16px;position:absolute;color:", ";}& select{height:42px;border-radius:8px;cursor:pointer;outline:none;padding:10px 16px;width:100%;-webkit-appearance:none;appearance:none;transition:all 0.2s ease-in-out;border:1px solid ", ";}select:hover{border:1px solid ", ";}select{color:", ";}select option{color:", ";}select:has(option:checked:not([value])),select:has(option:checked:not([value=''])){color:", ";}select:has(option:checked:not([value])) option,select:has(option:checked:not([value=''])) option{color:", ";}& ", "{position:absolute;top:50%;right:16px;transform:translateY(-50%);pointer-events:none;}"], ({
  theme
}) => theme.getColor('gray600'), ({
  theme,
  hasError
}) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), props => props.theme.getColor('borderActive'), props => props.theme.getColor('textSecondary'), props => props.theme.getColor('textPrimary'), props => props.theme.getColor('textPrimary'), props => props.theme.getColor('textPrimary'), IconWrapper);
const CountrySelector = props => {
  const {
      hasError
    } = props,
    otherProps = __rest(props, ["hasError"]);
  return jsx(Wrapper$2, Object.assign({
    hasError: hasError
  }, {
    children: jsx(CountryDropdown, Object.assign({}, otherProps))
  }));
};
const RegionSelector = props => {
  const {
      hasError
    } = props,
    otherProps = __rest(props, ["hasError"]);
  return jsxs(Wrapper$2, Object.assign({
    hasError: hasError
  }, {
    children: [jsx(IconWrapper, {
      children: jsx(ChevronDown, {
        color: "textPrimary"
      })
    }), jsx(RegionDropdown, Object.assign({}, otherProps))]
  }));
};

const Radio = /*#__PURE__*/styled(_Radio).withConfig({
  displayName: "radio__Radio",
  componentId: "sc-12hgnq3-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["font-weight:normal;font-size:14px;font-family:'Plus Jakarta Sans',sans-serif;align-items:center;& .", "-radio{top:unset;}& .", "-radio-input:focus + .", "-radio-inner{box-shadow:unset;}&.", "-radio-wrapper:hover .", "-radio,&.", "-radio-wrapper:hover .", "-radio-inner,& .", "-radio:hover .", "-radio-inner,& .", "-radio-input:focus + .", "-radio-inner{border-color:", ";}& .", "-radio-checked .", "-radio-inner{border-color:", ";}& .", "-radio-inner{width:20px;height:20px;}& .", "-radio-inner::after{width:20px;height:20px;margin-top:-10px;margin-left:-10px;background-color:", ";}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600);
});
Radio.Group = _Radio.Group;

const Switch = /*#__PURE__*/styled(_Switch).withConfig({
  displayName: "switch__Switch",
  componentId: "sc-1cy9kru-0"
})(["margin:0;min-width:40px;height:24px;.ant4-switch-handle{left:5px;width:14px;height:14px;top:5px;}&.ant4-switch-checked .ant4-switch-handle{left:calc(100% - 18px - 1px);}"]);
Switch.displayName = 'Switch';

var $$3 = _export;
var NativePromise = nativePromiseConstructor;
var fails$3 = fails$d;
var getBuiltIn = getBuiltIn$6;
var speciesConstructor = speciesConstructor$2;
var promiseResolve = promiseResolve$2;
var redefine$1 = redefine$6.exports;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromise && fails$3(function () {
  NativePromise.prototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
$$3({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = typeof onFinally == 'function';
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// patch native Promise.prototype for native async functions
if (typeof NativePromise == 'function' && !NativePromise.prototype['finally']) {
  redefine$1(NativePromise.prototype, 'finally', getBuiltIn('Promise').prototype['finally']);
}

var anObject$1 = anObject$b;

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$2 = fails$d;

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

regexpStickyHelpers.UNSUPPORTED_Y = fails$2(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$2(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$2 = _export;
var exec = regexpExec$2;

$$2({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine = redefine$6.exports;
var fails$1 = fails$d;
var wellKnownSymbol = wellKnownSymbol$g;
var regexpExec$1 = regexpExec$2;
var createNonEnumerableProperty = createNonEnumerableProperty$8;

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$1(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$1(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec$1) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};

var toInteger$1 = toInteger$4;
var requireObjectCoercible$2 = requireObjectCoercible$6;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$2($this));
    var position = toInteger$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

var classof = classofRaw$1;
var regexpExec = regexpExec$2;

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$b;
var toObject$1 = toObject$4;
var toLength$1 = toLength$4;
var toInteger = toInteger$4;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var advanceStringIndex = advanceStringIndex$1;
var regExpExec = regexpExecAbstract;

var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject$1(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

const spinAnimation = /*#__PURE__*/keyframes(["100%{transform:rotate(360deg);}"]);
const AnimatedLoading = /*#__PURE__*/styled(Loading).withConfig({
  displayName: "direct-upload__AnimatedLoading",
  componentId: "sc-1veoscz-0"
})(["color:", ";animation:", " 2s linear infinite;"], ({
  theme
}) => theme.getColor('gray600'), spinAnimation);
function DirectUpload(props) {
  const {
      style,
      fetcher,
      multiple,
      onSettled,
      payloadMapper
    } = props,
    otherProps = __rest(props, ["style", "fetcher", "multiple", "onSettled", "payloadMapper"]);
  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const renderErrorMsg = (fileName, error) => {
    var _a;
    const errMsgTitle = jsxs(Text, Object.assign({
      variant: "bodyDefault",
      color: "gray800",
      fontWeight: 600
    }, {
      children: ["Error: ", fileName, " has ", error === null || error === void 0 ? void 0 : error.message]
    }));
    const sourceFileErrs = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.source_file;
    if (sourceFileErrs && (sourceFileErrs === null || sourceFileErrs === void 0 ? void 0 : sourceFileErrs.length) > 0) {
      const errMsgs = sourceFileErrs.map(err => {
        const errMsg = jsx("li", Object.assign({
          style: {
            listStyle: 'outside',
            marginLeft: 20
          }
        }, {
          children: jsxs(Text, Object.assign({
            variant: "bodyDefault",
            color: "gray600"
          }, {
            children: [err.error && jsxs("span", {
              children: [jsx("span", Object.assign({
                style: {
                  fontWeight: 600
                }
              }, {
                children: capitalize((err.error || '').replace(/_/g, ' '))
              })), jsx("span", {
                children: `: `
              })]
            }), jsx("span", {
              children: err.message
            }), err.missing_columns && jsx("span", {
              children: ` ( ${err.missing_columns.join(', ')} )`
            }), err.unrecognized_columns && jsx("span", {
              children: ` ( ${err.unrecognized_columns.join(', ')} )`
            })]
          }))
        }), err.error);
        return errMsg;
      });
      return jsxs(_Space, Object.assign({
        direction: "vertical",
        size: 4
      }, {
        children: [errMsgTitle, jsx("ul", Object.assign({
          style: {
            display: 'flex',
            flexDirection: 'column'
          }
        }, {
          children: errMsgs
        })), jsxs(Text, Object.assign({
          variant: "bodyDefault"
        }, {
          children: ["Please ensure the first row of your file uses only the columns within the provided template. You can also", ' ', jsx("a", Object.assign({
            href: "https://docs.google.com/spreadsheets/d/1qVQvrFRIG9b5QXY-CJo4iZ-IntH17fTlKqvry0LvYV8/edit#gid=0",
            target: "_blank",
            rel: "noreferrer"
          }, {
            children: jsxs(Text, Object.assign({
              variant: "bodyDefault",
              color: "blue500"
            }, {
              children: ["view the instructions.", jsx(ExternalLink, {
                style: {
                  display: 'inline'
                },
                size: 15
              })]
            }))
          }))]
        }))]
      }));
    }
    return null;
  };
  const fileColumns = [{
    title: 'File',
    dataIndex: 'name',
    key: 'name',
    render: (fileName, record) => {
      var _a;
      const isSuccess = (record === null || record === void 0 ? void 0 : record.status) === 'success';
      const isError = (record === null || record === void 0 ? void 0 : record.status) === 'error';
      // const isUploading = record?.status === 'uploading';
      const statusMsg = isSuccess ? 'file upload success' : isError ? (_a = record.error) === null || _a === void 0 ? void 0 : _a.message : '';
      return jsxs(_Space, Object.assign({
        direction: "vertical",
        style: {
          width: '100%'
        },
        size: 0
      }, {
        children: [jsx(Tooltip, Object.assign({
          placement: "top",
          title: statusMsg
        }, {
          children: jsxs("div", Object.assign({
            style: {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }
          }, {
            children: [jsxs(_Space, Object.assign({
              size: 4
            }, {
              children: [isUploading && jsx(AnimatedLoading, {
                style: {
                  marginRight: 8
                }
              }), isError && jsx(Error$1, {
                color: "red500",
                style: {
                  marginTop: 2
                }
              }), isSuccess && jsx(Document, {
                color: "gray600"
              }), jsx("div", {
                children: jsx(Ellipsis, Object.assign({
                  maxWidth: "560px"
                }, {
                  children: fileName
                }))
              })]
            })), jsx(Cross, {
              color: "gray400",
              onClick: () => {
                const fList = fileList.filter(file => file.uid !== record.uid);
                setFileList(fList);
                if (isFunction(onSettled)) {
                  onSettled(fList);
                }
              }
            })]
          }))
        })), isError && jsx(FlexBox, Object.assign({
          color: "gray600",
          marginRight: 28
        }, {
          children: renderErrorMsg(fileName, record.error)
        }))]
      }));
    }
  }];
  return jsxs(_Space, Object.assign({
    direction: "vertical",
    style: Object.assign({
      width: '100%'
    }, style),
    size: 0
  }, {
    children: [jsx(Upload, Object.assign({
      content: jsxs(Fragment, {
        children: [jsx(Typography, Object.assign({
          color: "gray600",
          fontWeight: 600
        }, {
          children: "Select files"
        })), jsx(Typography, {
          children: "or drop your files here"
        }), jsx(Typography, Object.assign({
          color: "gray400"
        }, {
          children: "Max file size: 10mb"
        }))]
      }),
      multiple: multiple,
      fileList: fileList,
      showUploadList: false,
      customRequest: options => {
        var _a, _b, _c;
        const data = new FormData();
        data.append((payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileField) || 'source_file', options.file);
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        };
        setIsUploading(true);
        const fileObj = Object.assign(Object.assign({}, options.file), {
          name: (_a = options === null || options === void 0 ? void 0 : options.file) === null || _a === void 0 ? void 0 : _a.name,
          uid: (_b = options === null || options === void 0 ? void 0 : options.file) === null || _b === void 0 ? void 0 : _b.uid,
          fileName: (_c = options === null || options === void 0 ? void 0 : options.file) === null || _c === void 0 ? void 0 : _c.name,
          status: 'loading'
        });
        fetcher.post(options.action, data, config).then(res => {
          // throw 'wrong format';
          fileObj.status = 'success';
          setFileList(curList => {
            const newFileObj = Object.assign(Object.assign({}, fileObj), {
              response: res
            });
            const newList = multiple ? [...curList, newFileObj] : [newFileObj];
            if (isFunction(onSettled)) {
              onSettled(newList);
            }
            return newList;
          });
        }).catch(err => {
          var _a;
          _message.error(`upload failed: ${err.message}`);
          fileObj.status = 'error';
          fileObj.error = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
          setFileList(curList => {
            const newList = multiple ? [...curList, fileObj] : [fileObj];
            if (isFunction(onSettled)) {
              onSettled(newList);
            }
            return newList;
          });
        }).finally(() => {
          setIsUploading(false);
        });
      }
    }, otherProps)), jsx(_Spin, Object.assign({
      spinning: isUploading,
      style: {
        minHeight: 80
      }
    }, {
      children: fileList.length > 0 && jsx(FullWidthTable, {
        sticky: true,
        scroll: {
          y: 300
        },
        style: {
          marginTop: '20px'
        },
        dataSource: fileList,
        columns: fileColumns,
        pagination: false
      })
    }))]
  }));
}

const COLOR_MAPPER = {
  info: getColor('blue100'),
  warning: getColor('gold100'),
  error: getColor('red100')
};
const ICON_MAPPER = {
  info: jsx(Info, {
    color: "blue500"
  }),
  warning: jsx(Warning, {
    color: "gold500"
  }),
  error: jsx(Error$1, {
    color: "red500"
  })
};
const Wrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "inline-note__Wrapper",
  componentId: "sc-1wjgedg-0"
})(["display:flex;width:100%;padding:16px;border-radius:8px;background-color:", ";box-shadow:0px 1px 2px rgba(0,0,0,0.06),0px 1px 3px rgba(0,0,0,0.1);"], props => COLOR_MAPPER[props.variant || 'info']);
const InlineNote = props => {
  const {
    children,
    className,
    style = {},
    variant = 'info',
    icon
  } = props;
  return jsxs(Wrapper$1, Object.assign({
    className: className,
    variant: variant,
    style: style
  }, {
    children: [jsx("div", Object.assign({
      style: {
        marginRight: 10
      }
    }, {
      children: icon || ICON_MAPPER[variant]
    })), children]
  }));
};

const Pagination = /*#__PURE__*/styled(_Pagination).withConfig({
  displayName: "pagination__Pagination",
  componentId: "sc-1fei578-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css([".", "-pagination-prev,.", "-pagination-next{& button{border-radius:4px;display:flex;align-items:center;justify-content:center;}}.", "-select:not(.", "-select-customize-input) .", "-select-selector{border-radius:4px;}.", "-pagination-prev,.", "-pagination-next{display:inline-flex;justify-content:center;align-items:center;}.", "-pagination-item-link{flex:1;display:inline-flex;height:100%;width:100%;}.", "-pagination-jump-prev,.", "-pagination-jump-next{display:inline-flex;justify-content:center;align-items:center;}.", "-pagination-item-container{flex:1;display:flex;align-items:center;justify-content:center;}.", "-pagination-item{border-radius:4px;}.", "-pagination-item-active{background-color:", ";& a{color:", ";}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.blue500, props.theme.colors.white);
});

const StyledTrigger = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledTrigger",
  componentId: "sc-15u8gl2-0"
})(["&:hover{.btn{background:", ";}}&.active{.btn{border-color:", ";}}.btn{.icon-down{display:initial;}.icon-up{display:none;}}&.pressed{.btn{border-color:", ";background:", ";.icon-down{display:none;}.icon-up{display:initial;}}}"], ({
  theme
}) => theme.getColor('gray100'), ({
  theme
}) => theme.getColor('gray800'), ({
  theme
}) => theme.getColor('gray800'), ({
  theme
}) => theme.getColor('gray200'));
const StyledCheckboxWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledCheckboxWrapper",
  componentId: "sc-15u8gl2-1"
})([".ant-checkbox-wrapper{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;}"]);
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "dropdown-select__StyledButton",
  componentId: "sc-15u8gl2-2"
})(["border-radius:8px;width:100%;...props?.style;"]);
const Overlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__Overlay",
  componentId: "sc-15u8gl2-3"
})(["background:#fff;width:300px;border-radius:8px;box-shadow:0px 4px 20px rgba(0,0,0,0.08);overflow:hidden;&.width-auto{width:auto;}"]);
const StyledFooter = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledFooter",
  componentId: "sc-15u8gl2-4"
})(["padding:12px 20px;display:flex;align-items:center;justify-content:space-between;border-top:1px solid ", ";"], ({
  theme
}) => theme.getColor('gray300'));
const StyledTriggerContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledTriggerContent",
  componentId: "sc-15u8gl2-5"
})(["display:flex;align-items:center;line-height:34px;font-weight:400;width:100%;justify-content:space-between;gap:8px;.title{overflow:hidden;text-overflow:ellipsis;}"]);
const DropdownSelectItem = props => {
  const {
    checked,
    indeterminate = false,
    children,
    onChange,
    checkboxDataTestId
  } = props;
  return jsx(StyledCheckboxWrapper, {
    children: jsx(Checkbox, Object.assign({
      "data-testid": checkboxDataTestId,
      checked: checked,
      indeterminate: indeterminate,
      onChange: e => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked);
      }
    }, {
      children: jsx(Typography, Object.assign({
        color: "gray800"
      }, {
        children: children
      }))
    }))
  });
};
const DropdownSelect = props => {
  const {
    options,
    multiple = true,
    title,
    value,
    showSelectAll = false,
    overlayClassName,
    infinite = false,
    infiniteProps = {
      next: () => null,
      hasMore: false,
      loader: undefined,
      dataLength: 0
    },
    showManageButton = false,
    manageButtonLabel = 'Manage',
    onManageClick = noop,
    buttonStyle,
    wrapperStyle = {},
    contentValue,
    dataTestId,
    checkboxDataTestIdPrefix
  } = props;
  const propsRef = useRef(props);
  propsRef.current = props;
  const [innerValue, setInnerValue] = useState(value && Array.isArray(value) ? value : []);
  const [visible, setVisible] = useState(false);
  const domRef = useRef(null);
  const triggerRef = useRef(null);
  const handleClickOutOfContainer = useCallback(e => {
    var _a, _b;
    if (visible && triggerRef.current && !((_b = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, e.target))) {
      setTimeout(() => {
        setVisible(false);
      }, 10);
    }
  }, [visible]);
  const onCheckChange = useCallback(val => {
    const {
      onChange
    } = propsRef.current;
    setInnerValue(val);
    setTimeout(() => {
      onChange === null || onChange === void 0 ? void 0 : onChange(val);
    }, 10);
  }, []);
  const onCheckAll = useCallback(checked => {
    const newVal = checked ? [...(options || []).map(ele => ele.value)] : [];
    onCheckChange(newVal);
  }, [options, onCheckChange]);
  const onCheckItem = useCallback((checked, item) => {
    let newVal = [...innerValue];
    if (multiple) {
      if (checked) {
        newVal.push(item.value);
      } else {
        newVal = newVal.filter(v => v !== item.value);
      }
    } else {
      newVal = [item.value];
    }
    onCheckChange(newVal);
  }, [innerValue, multiple, onCheckChange]);
  useClickOutside(domRef, handleClickOutOfContainer);
  const overlay = useMemo(() => {
    const content = jsxs(Fragment, {
      children: [showSelectAll && multiple ? jsx(DropdownSelectItem, Object.assign({
        checked: (innerValue === null || innerValue === void 0 ? void 0 : innerValue.length) === (options === null || options === void 0 ? void 0 : options.length),
        indeterminate: !!(innerValue.length && options.length && innerValue.length < options.length),
        onChange: onCheckAll,
        checkboxDataTestId: `${checkboxDataTestIdPrefix}-all`
      }, {
        children: jsx(Typography, Object.assign({
          fontWeight: 600,
          color: "gray800"
        }, {
          children: "All"
        }))
      })) : null, options === null || options === void 0 ? void 0 : options.map((ele, index) => {
        return jsx("div", Object.assign({
          style: {
            marginTop: !index && !showSelectAll ? 0 : 20
          }
        }, {
          children: jsxs(DropdownSelectItem, Object.assign({
            checkboxDataTestId: `${checkboxDataTestIdPrefix}-${ele.value}`,
            checked: innerValue === null || innerValue === void 0 ? void 0 : innerValue.includes(ele.value),
            onChange: checked => onCheckItem(checked, ele)
          }, {
            children: [jsx(Typography, Object.assign({
              color: "gray800"
            }, {
              children: ele.label
            })), (ele === null || ele === void 0 ? void 0 : ele.caption) && jsx(Typography, Object.assign({
              variant: "caption",
              color: "gray600"
            }, {
              children: ele.caption
            }))]
          }))
        }), ele.value);
      })]
    });
    return jsxs(Overlay, Object.assign({
      ref: domRef,
      className: classNames([overlayClassName, infinite ? 'infinite-scroll' : ''])
    }, {
      children: [infinite ? jsx("div", Object.assign({
        style: {
          maxHeight: 200,
          padding: '30px 20px',
          overflow: visible ? 'auto' : 'hidden'
        },
        id: "dropdown-select-infinite-scroll-wrapper"
      }, {
        children: jsx(ReactInfiniteScrollComponent, Object.assign({
          scrollableTarget: "dropdown-select-infinite-scroll-wrapper"
        }, infiniteProps, {
          children: content
        }))
      })) : jsx("div", Object.assign({
        style: {
          padding: '30px 20px',
          maxHeight: 300,
          overflowY: visible ? 'auto' : 'hidden'
        }
      }, {
        children: content
      })), jsxs(StyledFooter, {
        children: [jsx("button", Object.assign({
          onClick: () => {
            onCheckAll(false);
          },
          "data-testid": "dropdown_select_clear",
          "aria-hidden": "true"
        }, {
          children: jsx(Typography, Object.assign({
            color: "blue600"
          }, {
            children: "Clear"
          }))
        })), showManageButton && jsx("div", Object.assign({
          onClick: () => {
            onManageClick();
            setVisible(false);
          }
        }, {
          children: jsx(Typography, Object.assign({
            variant: "link",
            color: "blue600"
          }, {
            children: manageButtonLabel
          }))
        }))]
      })]
    }));
  }, [checkboxDataTestIdPrefix, infinite, infiniteProps, innerValue, manageButtonLabel, multiple, onCheckAll, onCheckItem, onManageClick, options, overlayClassName, showManageButton, showSelectAll, visible]);
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setInnerValue(value);
    }
  }, [value]);
  return jsx("div", Object.assign({
    ref: triggerRef,
    style: wrapperStyle
  }, {
    children: jsx(_Dropdown, Object.assign({
      overlay: overlay,
      visible: visible
    }, {
      children: jsx(StyledTrigger, Object.assign({
        className: visible ? 'pressed' : (value === null || value === void 0 ? void 0 : value.length) ? 'active' : ''
      }, {
        children: jsxs(StyledButton, Object.assign({
          "data-testid": dataTestId,
          style: buttonStyle,
          size: "compact",
          onClick: () => {
            setVisible(!visible);
          }
        }, {
          children: [contentValue, jsxs(StyledTriggerContent, {
            children: [jsx("div", Object.assign({
              className: "title"
            }, {
              children: title
            })), jsx(SmallChevronUp, {
              className: "icon-up",
              size: 18
            }), jsx(SmallChevronDown, {
              className: "icon-down",
              size: 18
            })]
          })]
        }))
      }))
    }))
  }));
};

const WarnButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "warn-button__WarnButton",
  componentId: "sc-13uq3g7-0"
})(["color:#ffffff;background:", ";border:", ";&:hover{background:", ";}&.disabled{color:#ffffff;background:", ";}&.loading{background:", ";}"], props => props.theme.colors.red500, props => props.theme.colors.red500, props => props.theme.colors.red300, props => props.theme.colors.red200, props => props.theme.colors.red300);

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var requireObjectCoercible = requireObjectCoercible$6;
var whitespaces$1 = whitespaces$2;

var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var global$1 = global$k;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt = global$1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;

var $$1 = _export;
var parseIntImplementation = numberParseInt;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$$1({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});

/**
 * adds dimension to a given styling param in px
 */
const addUnitDimensions = (numOrStr, quantityAdded) => {
  let newDimension;
  switch (typeof numOrStr) {
    case 'string':
      newDimension = parseInt(numOrStr, 10) + quantityAdded;
      return String(newDimension) + 'px';
    case 'number':
      return String(numOrStr + quantityAdded) + 'px';
    default:
      return 'initial';
  }
};

const offsetPixelDimension = 6;
const defaultValue = (width, height) => typeof width == 'undefined' && typeof height == 'undefined' ? 40 : '100%';
// component container
const AvatarContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "user-avatarstyles__AvatarContainer",
  componentId: "sc-1nsydm0-0"
})(["position:relative;height:", ";width:", ";opacity:", ";display:flex;justify-content:center;align-items:center;"], prop => addUnitDimensions(prop.height || defaultValue(prop.width, prop.height), offsetPixelDimension), prop => addUnitDimensions(prop.width || defaultValue(prop.width, prop.height), offsetPixelDimension), prop => prop.isInactive === true || prop.isArchived === true ? 0.4 : 1);
const avatarComponent = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidator) => defaultValidator(prop),
  displayName: "user-avatarstyles__avatarComponent",
  componentId: "sc-1nsydm0-1"
})(props => {
  const {
    additionalStyle,
    theme
  } = props;
  return css(["display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:50%;width:", ";height:", ";background:", ";background-size:cover;background-position:center;.avatar_initials{font-size:", ";line-height:", ";color:", ";font-weight:600;}"], props.width || defaultValue(props.width, props.height), props.height || defaultValue(props.width, props.height), props.src ? `url(${props.src})` : additionalStyle === null || additionalStyle === void 0 ? void 0 : additionalStyle.bgColor, props.fontSize || 'inherit', props.lineHeight, (additionalStyle === null || additionalStyle === void 0 ? void 0 : additionalStyle.color) && theme.getColor(additionalStyle === null || additionalStyle === void 0 ? void 0 : additionalStyle.color));
});
const avatarRingComponent = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidator) => defaultValidator(prop),
  displayName: "user-avatarstyles__avatarRingComponent",
  componentId: "sc-1nsydm0-2"
})(props => css(["height:", ";width:", ";border:2px solid ", ";border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);opacity:", ";"], addUnitDimensions(props.height || defaultValue(props.width, props.height), offsetPixelDimension), addUnitDimensions(props.width || defaultValue(props.width, props.height), offsetPixelDimension), props.isApplicant ? props.theme.colors.blue400 : '#F2A65A', props.showBorder ? 1 : 0));

var aFunction = aFunction$6;
var toObject = toObject$4;
var IndexedObject = indexedObject;
var toLength = toLength$4;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails = fails$d;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $ = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var arrayMethodUsesToLength = arrayMethodUsesToLength$2;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

const AVATAR_COLORS_1 = ['#D4D4D8', '#DAE5FF', '#F7B950', '#2DC294', '#FFED4A', '#ECC5CC', '#75C3FA']; // colors with black text
const AVATAR_COLORS_2 = ['#787883', '#457CFF', '#303F9F', '#218F47', '#7B80B7', '#D88C9A', '#1E699F']; // colors with white text
const defaultPropsBySize = {
  default: {
    height: '40px',
    width: '40px',
    fontSize: '14px',
    lineHeight: '20px'
  },
  small: {
    height: '28px',
    width: '28px',
    fontSize: '10px',
    lineHeight: '20px'
  },
  medium: {
    height: '40px',
    width: '40px',
    fontSize: '14px',
    lineHeight: '20px'
  },
  large: {
    height: '60px',
    width: '60px',
    fontSize: '20px',
    lineHeight: '28px'
  }
};
function getColorsBySeed(seed) {
  if (!seed) {
    return {
      bgColor: AVATAR_COLORS_2[0],
      color: 'white'
    };
  }
  const numberArg = parseInt(seed.split('').reduce((a, b) => a + b.charCodeAt(0), ''));
  const index = numberArg % 7;
  const colorArr = numberArg % 2 === 0 ? AVATAR_COLORS_1 : AVATAR_COLORS_2;
  if (index >= 0) {
    return {
      bgColor: colorArr[index],
      color: colorArr === AVATAR_COLORS_1 ? 'gray800' : 'white'
    };
  }
  return {
    bgColor: AVATAR_COLORS_2[0],
    color: 'white'
  };
}

/**
 *
 * @param props
 * @returns
 *
 * TODO: verify wsWrapper implementation and replace eventually
 */
const UserAvatar = props => {
  const isDsAdoptAvatarOn = useFeatureIsOn('ds-adopt-avatar');
  const {
    firstName = '',
    lastName = '',
    src = '',
    size = 'default',
    id,
    showBorder = false,
    isInactive = false,
    isArchived = false,
    showFullName = false,
    wsWrapper = isDsAdoptAvatarOn,
    alt
  } = props;
  const mergedProps = defaults(Object.assign({}, omit(props, 'id')), defaultPropsBySize[size]);
  const name = useMemo(() => {
    return showFullName ? `${firstName}${lastName}` : (((firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)) || '') + ((lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0)) || '')).toUpperCase();
  }, [firstName, lastName, showFullName]);
  const stylesForAvatar = useMemo(() => {
    return getColorsBySeed(firstName || lastName ? String(id) : '');
  }, [firstName, lastName, id]);
  if (wsWrapper) {
    const {
        isApplicant,
        showBorder: _showBorder,
        isInactive: _isInactive,
        isArchived: _isArchived
      } = mergedProps,
      restProps = __rest(mergedProps, ["isApplicant", "showBorder", "isInactive", "isArchived"]);
    if (src && !alt) {
      console.warn('[Avatar(hr-ui)] must have alt prop defined if src is defined! Now src is used as alt.');
    }
    return jsx(Box, Object.assign({
      padding: "1px",
      border: 2,
      borderColor: _showBorder ? isApplicant ? 'blue400' : '#F2A65A' : 'transparent',
      borderRadius: "chips",
      style: {
        opacity: _isInactive || _isArchived ? 0.4 : 1
      }
    }, {
      children: jsx(Avatar$1, Object.assign({
        "$size": "medium",
        seed: String(id),
        alt: src,
        getColorsBySeed: getColorsBySeed
      }, restProps, {
        children: name
      }))
    }));
  }
  return jsxs(AvatarContainer, Object.assign({
    size: size,
    isArchived: isArchived,
    isInactive: isInactive
  }, mergedProps, {
    children: [jsx(avatarRingComponent, Object.assign({
      showBorder: showBorder,
      size: size
    }, mergedProps)), jsx(avatarComponent, Object.assign({
      className: "avatar_wrapper",
      "data-testid": "profile_avatar"
    }, mergedProps, {
      additionalStyle: stylesForAvatar
    }, {
      children: jsx(Typography, Object.assign({
        className: "avatar_initials"
      }, {
        children: !src ? name : ''
      }))
    }))]
  }));
};

const useAutoSize = (textAreaRef, defaultSet, value, maxHeight) => {
  useEffect(() => {
    if (textAreaRef) {
      textAreaRef.style.height = '0px';
      const scrollHeight = textAreaRef.scrollHeight;
      const newHeight = maxHeight && scrollHeight >= maxHeight ? maxHeight : scrollHeight;
      textAreaRef.style.height = newHeight + 'px';
    }
  }, [textAreaRef, defaultSet, value, maxHeight]);
};

const TextArea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "text-area-grow__TextArea",
  componentId: "sc-1wpacsh-0"
})(["width:100%;resize:none;border:1px solid ", ";padding:14px 16px;font-family:'Plus Jakarta Sans';font-size:14px;line-height:20px;border-radius:20px;overflow-y:auto;resize:none;scroll-padding:14px;box-sizing:border-box;::-webkit-scrollbar{width:0 !important;}-ms-overflow-style:none;scrollbar-width:none;&::placeholder{color:", ";font-size:14px;line-height:20px;font-family:'Plus Jakarta Sans';}&:focus,&:active{border:1px solid ", ";outline:none;}", ""], colors$1.gray400, colors$1.gray600, colors$1.gray800, props => props.$borderColor && `
    border-color: ${getColor$1(props.$borderColor)};

    // override active color only when it is not special status color
    &:focus,
    &:active {
      border-color: ${getColor$1(props.$borderColor) !== colors$1.gray400 ? getColor$1(props.$borderColor) : colors$1.gray800} !important;
    }
  `);
const TextAreaContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "text-area-grow__TextAreaContainer",
  componentId: "sc-1wpacsh-1"
})(["display:flex;width:100%;flex-direction:column;align-items:flex-end;"]);
const TextAreaGrow = props => {
  const {
    value,
    maxHeight = 108
  } = props;
  const textAreaRef = useRef(null);
  const [defaultSet, setDefaultSet] = useState(false);
  useAutoSize(textAreaRef.current, defaultSet, value, maxHeight);
  /** you're probably wondering why this is needed. its because if there's a default value,
  the textarea will not grow on the first render. this is because the ref is still null
  so this forces the autosize to trigger
  bad hacks 101
  */
  useEffect(() => {
    setDefaultSet(true);
  }, []);
  const renderMessage = () => {
    if (props.message) {
      return jsx(Typography, Object.assign({
        color: getStatusColor()
      }, {
        children: props.message
      }));
    }
    return null;
  };
  const getStatusColor = () => {
    let color = 'gray400';
    switch (props.status) {
      case 'error':
        color = 'red500';
        break;
      case 'warning':
        color = 'gold500';
        break;
    }
    return color;
  };
  return jsxs(TextAreaContainer, {
    children: [jsx(TextArea, Object.assign({
      ref: textAreaRef,
      rows: 1
    }, props, {
      "$borderColor": getStatusColor()
    })), renderMessage()]
  });
};

var img$3 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='113px' height='164px' viewBox='0 0 113 164' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch --%3e %3ctitle%3eghost%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e %3cpath d='M84.5165882%2c10.3461071 C100.09547%2c21.8146249 103.5%2c30 105.516588%2c41.8461071 C106.86098%2c49.7435119 106.86098%2c73.7435119 105.516588%2c113.846107 L95.5%2c102.5 L85%2c114.5 L75%2c102.5 L64%2c114.5 L54%2c102.5 L43.5%2c114.672187 L33.5%2c102.5 L23%2c114.672187 L13.5%2c102.5 L1.01658823%2c114.672187 C-0.305686288%2c75.0188717 -0.305686288%2c50.7435119 1.01658823%2c41.8461071 C3%2c28.5 7.39649968%2c22.7471669 22.5%2c11 C45%2c-6.5 72.5%2c1.5 84.5165882%2c10.3461071 Z' id='path-1'%3e%3c/path%3e %3c/defs%3e %3cg id='Test' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='404' transform='translate(-409.000000%2c -275.000000)'%3e %3cg id='Group-3' transform='translate(412.000000%2c 278.000000)'%3e %3cg id='Group-2'%3e %3cg id='ghost'%3e %3cellipse id='Oval-5' fill='%23EFF1EF' cx='54' cy='156' rx='52' ry='5'%3e%3c/ellipse%3e %3cpath d='M16.5%2c123.5 C20%2c135 96.5450773%2c127.950773 97%2c132.5 C97.5%2c137.5 10.5%2c138.5 11.5%2c144.5 C12.2798379%2c149.179027 26.2798379%2c151.512361 53.5%2c151.5' id='Line-2' stroke='%23D1D1D1' stroke-width='2' stroke-linecap='square' stroke-dasharray='1%2c6%2c1%2c1'%3e%3c/path%3e %3cpolygon id='Star' stroke='%23979797' stroke-width='2' fill='%23F5F6FA' transform='translate(70.159180%2c 144.883476) rotate(-46.000000) translate(-70.159180%2c -144.883476) ' points='70.1591796 149.215728 64.0324506 151.010205 65.826928 144.883476 64.0324506 138.756747 70.1591796 140.551224 76.2859086 138.756747 74.4914312 144.883476 76.2859086 151.010205'%3e%3c/polygon%3e %3ccircle id='Oval-3' stroke='%23979797' stroke-width='2' fill='%23F5F6FA' cx='44.5' cy='138.5' r='4.5'%3e%3c/circle%3e %3ccircle id='Oval-2' stroke='%23979797' fill='%23F5F6FA' cx='27' cy='122' r='2'%3e%3c/circle%3e %3ccircle id='Oval-2' stroke='%23979797' fill='%23F5F6FA' cx='88.5' cy='141.5' r='1.5'%3e%3c/circle%3e %3cpath d='M73.368724%2c122.457376 L71.9185078%2c120.58816 L70.4316699%2c122.457376 C70.216822%2c122.718596 70.0349364%2c122.904874 69.8860077%2c123.016214 C69.7370791%2c123.127554 69.5478692%2c123.183223 69.3183726%2c123.183223 C69.0644614%2c123.183223 68.848396%2c123.113636 68.6701699%2c122.974462 C68.4919438%2c122.835287 68.402832%2c122.675773 68.402832%2c122.495916 C68.402832%2c122.311777 68.5395514%2c122.04842 68.8129942%2c121.705835 L70.6221023%2c119.431943 L69.0180753%2c117.537033 C68.7397496%2c117.224425 68.6005888%2c116.952503 68.6005888%2c116.721259 C68.6005888%2c116.541402 68.683597%2c116.3851 68.8496158%2c116.252349 C69.0156347%2c116.119597 69.2329208%2c116.053223 69.5014807%2c116.053223 C69.7358602%2c116.053223 69.9299529%2c116.111033 70.0837645%2c116.226655 C70.2375761%2c116.342277 70.4170202%2c116.524272 70.6221023%2c116.772646 L71.9185078%2c118.327115 L73.1782916%2c116.772646 C73.3882566%2c116.515708 73.5701421%2c116.331572 73.7239537%2c116.220232 C73.8777653%2c116.108892 74.0694165%2c116.053223 74.2989132%2c116.053223 C74.5625902%2c116.053223 74.781097%2c116.118527 74.9544402%2c116.249137 C75.1277834%2c116.379747 75.2144537%2c116.53712 75.2144537%2c116.721259 C75.2144537%2c116.85401 75.1790532%2c116.981407 75.108251%2c117.103452 C75.0374489%2c117.225498 74.9288058%2c117.370024 74.7823186%2c117.537033 L73.1782916%2c119.431943 L74.9873997%2c121.705835 C75.2706083%2c122.061267 75.4122105%2c122.328907 75.4122105%2c122.508763 C75.4122105%2c122.692902 75.3243195%2c122.851345 75.1485348%2c122.984097 C74.9727502%2c123.116848 74.755464%2c123.183223 74.49667%2c123.183223 C74.2671733%2c123.183223 74.0730807%2c123.125413 73.9143862%2c123.00979 C73.7556917%2c122.894168 73.5738061%2c122.710032 73.368724%2c122.457376 Z' id='x' fill='%23949596'%3e%3c/path%3e %3cg id='Rectangle-3'%3e %3cmask id='mask-2' fill='white'%3e %3cuse xlink:href='%23path-1'%3e%3c/use%3e %3c/mask%3e %3cg id='Mask'%3e %3cuse fill='%23F5F6FA' fill-rule='evenodd' xlink:href='%23path-1'%3e%3c/use%3e %3cpath stroke='%23949596' stroke-width='3' d='M95.5050133%2c104.772159 L84.9721765%2c116.809687 L74.9462066%2c104.778523 L63.9462066%2c116.778523 L53.9802406%2c104.819364 L43.4720103%2c117.001091 L33.4720103%2c104.828905 L22.9420079%2c117.035872 L13.3480088%2c104.743246 L-0.36932221%2c118.118588 L-0.482578507%2c114.722178 C-1.80854101%2c74.9582647 -1.80854101%2c50.6518695 -0.46711672%2c41.6256085 C1.53739923%2c28.1374943 5.83268151%2c22.0631776 21.5790891%2c9.81597167 C32.2223154%2c1.53790675 44.659302%2c-1.76058178 57.5622574%2c-0.701711081 C68.1120865%2c0.164052194 78.4414708%2c4.0112448 85.4058511%2c9.13812881 C99.8098519%2c19.7417487 104.60182%2c27.5341979 106.995315%2c41.5943802 C108.364666%2c49.6384015 108.364666%2c73.6587002 107.015746%2c113.896365 L106.889322%2c117.667527 L95.5050133%2c104.772159 Z'%3e%3c/path%3e %3c/g%3e %3cpath d='M51%2c-5.42101086e-17 C51.4480077%2c0.00153007755 51.781341%2c0.00153007755 52%2c-2.31065167e-15 C81.0179062%2c-0.203054278 99.5101585%2c14.3033779 105.5%2c37.5140137 C105.996993%2c39.4398598 106.330326%2c41.2731931 106.5%2c43.0140137 L106.5%2c115.5 L96%2c102.5 C97.3333333%2c68.5 96.5%2c47.3333333 93.5%2c39 C86.9215687%2c20.7265796 72.754902%2c7.72657959 51%2c-5.42101086e-17 Z' fill='%23D8D8D8' opacity='0.539175725' mask='url(%23mask-2)'%3e%3c/path%3e %3c/g%3e %3crect id='Rectangle-2' fill='%23949596' x='47' y='83' width='15' height='3' rx='1.5'%3e%3c/rect%3e %3ccircle id='Oval' fill='%23949596' cx='81' cy='56' r='3'%3e%3c/circle%3e %3ccircle id='Oval' fill='%23949596' cx='28' cy='56' r='3'%3e%3c/circle%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

// This is just a temporary page until Paywall goes full GA
const ERErrorPage = props => {
  return jsx("div", Object.assign({
    className: (props === null || props === void 0 ? void 0 : props.className) || ''
  }, {
    children: jsxs("div", Object.assign({
      className: "error-container"
    }, {
      children: [jsx("div", Object.assign({
        className: "left"
      }, {
        children: jsx("img", {
          src: img$3,
          alt: "error"
        })
      })), jsxs("div", Object.assign({
        className: "right"
      }, {
        children: [jsx("div", Object.assign({
          className: "row title"
        }, {
          children: jsx("span", Object.assign({
            className: "top-label"
          }, {
            children: "Something went wrong!"
          }))
        })), jsx("div", Object.assign({
          className: "row content"
        }, {
          children: jsx("span", Object.assign({
            className: "bottom-label"
          }, {
            children: "Please check your browser console for error details."
          }))
        }))]
      }))]
    }))
  }));
};
const ErrorPlaceholder = /*#__PURE__*/styled(ERErrorPage).withConfig({
  displayName: "error-placeholder__ErrorPlaceholder",
  componentId: "sc-159zmmz-0"
})(["width:100vw;height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#f5f6fa;& .error-container{width:30rem;height:20rem;padding:1rem;display:flex;justify-content:center;align-items:center;& .left{display:flex;}& .right{margin-left:4rem;display:flex;flex-direction:column;& .title{font-size:2rem;}& .content{font-size:1rem;}& .row:not(:first-child){margin-top:1rem;}& .top-label{color:#9e9fa0;font-family:Segoe UI;font-size:20px;font-weight:600;font-style:normal;}& .bottom-label{color:#9e9fa0;font-size:13px;font-style:normal;}}}"]);

const LoadingWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loading-placeholder__LoadingWrapper",
  componentId: "sc-7fxcik-0"
})(["display:flex;justify-content:center;align-items:center;height:100%;width:100%;position:relative;"]);
const LoadingPlaceholder = () => {
  return jsx(LoadingWrapper, {
    children: jsx(_Spin, {
      size: "large"
    })
  });
};

const ListSearchInputInner = _a => {
  var {
      searchKey = 'query',
      searchOnChange,
      placeholder = 'Search team members',
      autoClearPage = true,
      debounceDelay = 0
    } = _a,
    props = __rest(_a, ["searchKey", "searchOnChange", "placeholder", "autoClearPage", "debounceDelay"]);
  const [urlState, setUrlState] = useUrlState({
    [searchKey]: undefined
  });
  const searchValue = urlState[searchKey];
  const [searchText, setSearchText] = useState(searchValue);
  const debouncedSearchText = useDebounce(searchText, {
    wait: debounceDelay
  });
  const setSearchValue = useCallback(value => {
    setUrlState(s => ({
      [searchKey]: value ? value : undefined,
      page: autoClearPage ? 1 : s['page']
    }));
  }, [searchKey, autoClearPage, setUrlState]);
  useEffect(() => {
    if (searchOnChange) {
      setSearchValue(debouncedSearchText);
    }
  }, [searchOnChange, debouncedSearchText, setSearchValue]);
  useEffect(() => {
    // Update seachText when searchValue from URL is changed by other components
    if (searchValue !== searchText) {
      setSearchText(searchValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);
  return jsx(_Input.Search, Object.assign({
    allowClear: true,
    value: searchText,
    onChange: e => {
      setSearchText(e.target.value);
    },
    onSearch: setSearchValue,
    placeholder: placeholder
  }, props));
};

const antdInputStyles = /*#__PURE__*/css(["border-radius:8px;padding:10px 16px 10px 16px !important;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;&:hover,&:focus{box-shadow:none;border-color:", ";}&::placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}"], props => props.theme.colors.gray800, props => props.theme.colors.gray600, props => props.theme.colors.gray600, props => props.theme.colors.gray600);
const ListSearchInput = /*#__PURE__*/styled(ListSearchInputInner).attrs(props => ({
  suffix: jsx(MagnifyingGlass, {
    style: {
      color: props.theme.colors.gray600,
      width: '16px',
      height: '16px',
      cursor: 'pointer'
    }
  })
})).withConfig({
  displayName: "list-search-input__ListSearchInput",
  componentId: "sc-y0e716-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["width:240px;height:40px;& .", "-input-affix-wrapper{padding:0 11px 0 0;border-radius:8px !important;height:40px;}& .", "-input-affix-wrapper + .", "-input-group-addon{display:none;}.", "-input-suffix{right:18px;}& .", "-input-affix-wrapper:not(.", "-input-affix-wrapper-disabled):hover{border-color:", ";}& .", "-input-affix-wrapper:focus,.", "-input-affix-wrapper-focused{box-shadow:none;border-color:", ";}& .", "-input{", "}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdInputStyles);
});

const DropDownMenu = /*#__PURE__*/styled(_Menu).withConfig({
  displayName: "dropdown-menu__DropDownMenu",
  componentId: "sc-9dm31y-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["border-radius:8px;box-shadow:0px 4px 20px rgba(0,0,0,0.08);.", "-dropdown-menu-submenu-title{min-height:44px;display:flex;align-items:center;}"], antdCssPrefix);
});

function RawPopover(_a) {
  var {
      className
    } = _a,
    otherProps = __rest(_a, ["className"]);
  return jsx(_Popover, Object.assign({}, otherProps, {
    overlayClassName: className
  }));
}
/**
 * Restyled antd popover component in the new design
 * language.
 */
const Popover = /*#__PURE__*/styled(RawPopover).withConfig({
  displayName: "popover__Popover",
  componentId: "sc-1ptrn5x-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["width:257px;font-family:'Plus Jakarta Sans';font-size:14px;line-height:20px;& .", "-popover-arrow{display:none;}& .", "-popover-content{padding:12px 12px 20px 20px;box-shadow:", ";border-radius:8px;background:#ffffff;}& .", "-popover-title{font-weight:600;color:", ";padding:0;border-bottom:none;}& .", "-popover-inner{box-shadow:none;}& .", "-popover-inner-content{padding:0;color:", ";& a{color:", ";}}"], antdCssPrefix, antdCssPrefix, theme.boxShadows.e3, antdCssPrefix, colors.gray800, antdCssPrefix, antdCssPrefix, colors.gray600, colors.textLink);
});

const antdCssPrefix = globalConfig().getPrefixCls();
const GlobalStyle$1 = /*#__PURE__*/createGlobalStyle([".", "-tooltip-inner{border-radius:8px;padding:8px;background:", ";font-size:12px;font-weight:normal;font-family:'Plus Jakarta Sans','Segoe UI',Roboto,Helvetica Neue,sans-serif;}"], antdCssPrefix, colors$1.gray900);
const TooltipV2 = props => {
  return jsxs(Fragment, {
    children: [jsx(GlobalStyle$1, {}), jsx(_Tooltip, Object.assign({}, props))]
  });
};

const Collapse = /*#__PURE__*/styled(_Collapse).withConfig({
  displayName: "collapse__Collapse",
  componentId: "sc-t8krjv-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["border-radius:12px;box-shadow:0px 1px 2px rgba(0,0,0,0.06),0px 1px 3px rgba(0,0,0,0.1);border:none;.", "-collapse-item{&:first-child{border-radius:12px 12px 0 0;border-top-left-radius:12px;border-top-right-radius:12px;}&:last-child{border-bottom-left-radius:12px;border-bottom-right-radius:12px;}background:white;.", "-collapse-header{padding:24px 20px;}}.", "-collapse-content-box{padding:20px;}.", "-collapse-item:last-child{.", "-collapse-header{border-radius:12px 12px 0 0;}.", "-collapse-content{border-radius:0 0 12px 12px;}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix);
});

const {
  Item,
  SubMenu
} = DropDownMenu;
const DropdownPicker = props => {
  const {
    options = [],
    onClick = noop,
    value,
    children,
    showSelectedStatus,
    disabled = false
  } = props;
  const renderOptionItem = useCallback(option => {
    if (isFunction(option.render)) {
      return option.render(option);
    } else {
      return jsxs(FlexBox, Object.assign({
        direction: "row",
        justify: "space-between",
        style: {
          width: '100%'
        },
        align: "center"
      }, {
        children: [jsxs(FlexBox, Object.assign({
          direction: "column"
        }, {
          children: [jsx(Typography, {
            children: option.title
          }), option.caption && jsx(Typography, Object.assign({
            variant: "caption",
            color: "gray500"
          }, {
            children: option.caption
          }))]
        })), value === option.value && showSelectedStatus && jsx(Checkmark, {})]
      }));
    }
  }, [value, showSelectedStatus]);
  const renderMenu = useCallback(options => {
    return options.map(option => {
      const itemStyle = option.style || {};
      return (option === null || option === void 0 ? void 0 : option.isDivider) ? jsx("hr", {
        style: {
          color: getColor('gray200')
        }
      }, option.value) : (option === null || option === void 0 ? void 0 : option.children) && (option === null || option === void 0 ? void 0 : option.children.length) > 0 ? jsx(SubMenu, Object.assign({
        title: option === null || option === void 0 ? void 0 : option.title,
        style: {
          minHeight: '40px'
        }
      }, {
        children: renderMenu(option.children)
      }), `${option === null || option === void 0 ? void 0 : option.title}-submenu`) : jsx(Item, Object.assign({
        onClick: (option === null || option === void 0 ? void 0 : option.onClick) || noop,
        disabled: !!(option === null || option === void 0 ? void 0 : option.disabled)
      }, {
        children: jsx(FlexBox, Object.assign({
          justify: "space-between",
          style: Object.assign({
            width: '300px',
            minHeight: '40px'
          }, itemStyle)
        }, {
          children: renderOptionItem(option)
        }))
      }), option.value);
    });
  }, [renderOptionItem]);
  const menu = jsx(DropDownMenu, Object.assign({
    onClick: onClick
  }, {
    children: renderMenu(options)
  }));
  return jsx(_Dropdown, Object.assign({
    disabled: disabled,
    overlay: menu,
    trigger: ['click']
  }, {
    children: children
  }));
};

const PWModal = /*#__PURE__*/styled(Modal).withConfig({
  displayName: "paywall-modalstyles__PWModal",
  componentId: "sc-1px4pjl-0"
})(["width:700px !important;.ant4-modal-body{padding:0 !important;overflow:hidden !important;}.ant4-modal-footer{border-top:none !important;padding:0 !important;height:80px;display:", " !important;}.ant4-modal-close{display:", " !important;}"], ({
  showFooter
}) => showFooter ? 'block' : 'none', ({
  showClose
}) => showClose ? 'block' : 'none');
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Container",
  componentId: "sc-1px4pjl-1"
})(["display:flex;flex-direction:column;width:100%;height:100%;overflow:hidden;height:", ";"], ({
  height
}) => height ? `${height}px` : 'auto');
const Banner = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Banner",
  componentId: "sc-1px4pjl-2"
})(["height:298px;width:100%;border-top-right-radius:12px;border-top-left-radius:12px;background:", ";img{pointer-events:none;object-fit:cover;margin-left:auto;margin-right:auto;}overflow:hidden;"], ({
  gradient
}) => gradient || 'linear-gradient(164deg, rgba(123, 128, 183, 0.4), rgba(123, 128, 183, 0.15) 50%, rgba(123, 128, 183, 0.4))');
const Body = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Body",
  componentId: "sc-1px4pjl-3"
})(["position:relative;"]);
const BodyContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__BodyContent",
  componentId: "sc-1px4pjl-4"
})(["padding:32px;padding-top:40px;padding-bottom:12px;overflow:auto;position:relative;box-sizing:border-box;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"]);
const Footer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Footer",
  componentId: "sc-1px4pjl-6"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;height:80px;padding:10px 32px;border-top:", ";"], ({
  hasBorder
}) => hasBorder ? `1px solid ${colors.gray400}` : 'none');
const FooterLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "paywall-modalstyles__FooterLink",
  componentId: "sc-1px4pjl-7"
})(["color:rgba(104,114,138,1);font-size:14px;line-height:20px;font-family:'Plus Jakarta Sans';font-weight:600;display:flex;align-items:center;svg{margin-left:6px;width:16px;height:16px;}&:hover{color:rgba(104,114,138,0.8);}"]);
const FooterButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__FooterButtonContainer",
  componentId: "sc-1px4pjl-8"
})(["display:flex;align-items:center;justify-content:flex-end;gap:8px;button{min-width:100px;}"]);
const ConfirmButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "paywall-modalstyles__ConfirmButton",
  componentId: "sc-1px4pjl-9"
})(["background-color:", ";color:#fff;&:hover{background-color:", ";}&:active{background-color:", ";}svg{width:20px;margin-left:8px;}"], colors.blue500, colors.blue600, colors.blue700);
const PremiumTag = /*#__PURE__*/styled.span.withConfig({
  displayName: "paywall-modalstyles__PremiumTag",
  componentId: "sc-1px4pjl-10"
})(["background-color:", ";color:", ";padding:2px 8px;border-radius:4px;font-size:12px;font-weight:600;max-height:21px;max-width:68px;margin-left:8px;font-family:'Plus Jakarta Sans';"], colors.gold200, colors.gold800);
const BulletPointContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__BulletPointContainer",
  componentId: "sc-1px4pjl-11"
})(["display:flex;flex-direction:column;margin-top:32px;svg{width:16px;height:16px;margin-right:9px;color:", ";}.bulletpoint{margin-bottom:20px;}.bulletpoint:last-child{margin-bottom:0;}"], colors.textPrimary);
const FormHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__FormHeader",
  componentId: "sc-1px4pjl-13"
})(["height:64px;border-bottom:1px solid ", ";display:flex;align-items:center;padding:20px;button{display:grid;place-items:center;margin-top:1px;margin-right:4px;svg{color:#787883;}}"], colors.gray400);
const FormLine = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__FormLine",
  componentId: "sc-1px4pjl-14"
})(["height:1px;background-color:", ";position:absolute;width:100%;top:482px;"], colors.gray400);
const FormBackButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "paywall-modalstyles__FormBackButton",
  componentId: "sc-1px4pjl-15"
})(["position:absolute;top:505px;right:128px;min-width:100px;"]);
const formCSS = `
  * {
    font-family: 'Plus Jakarta Sans';
  }

  form {
    height: 500px;
    margin: 0;
    padding: 20px;
    padding-top: 0px;
    width: 700px;
    box-sizing: border-box;
    position: relative;
  }

  .hub-spot-form-submit-button {
    background-color: ${colors.blue500};
    padding: 10px 0;
    width: 100px;
    border-radius: 8px;
    border: none;
    color: ${colors.blue500};
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }

  input[type='submit'] {
    cursor: pointer;
  }

  .hub-spot-form-submit-button:hover {
    background-color: ${colors.blue600};
    color: ${colors.blue600};
  }

  .hub-spot-form-submit-button:active {
    background-color: ${colors.blue700};
    color: ${colors.blue700};
  }

  .hs-submit .actions::before {
    content: 'Submit';
    width: 100px;
    color: black;
    position: absolute;
    font-family: 'Plus Jakarta Sans';
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    pointer-events: none;
    top: 50%;
    transform: translateY(-50%);
  }

  .hs-submit .actions {
    position: absolute;
    right: 20px;
    top: 433px;
    margin: 0;
    padding: 0;
  }

  .hs-form-field input, select {
    background: none !important;
    -moz-appearance:none; /* Firefox */
    -webkit-appearance:none; /* Safari and Chrome */
    appearance:none;
    border-radius: 8px;
    border: 1px solid ${colors.gray400};
  }

  .hs-input select {
    border-radius: 8px;
    border: 1px solid ${colors.gray400};
  }

  .hs-error-msgs {
    display: none;
  }
`;
const Step2Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Step2Container",
  componentId: "sc-1px4pjl-16"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:546px;width:100%;"]);
const Spinner = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Spinner",
  componentId: "sc-1px4pjl-17"
})(["width:24px;height:24px;border:3.5px solid rgba(43,45,51,0.24);border-bottom-color:transparent;border-radius:50%;display:inline-block;box-sizing:border-box;animation:rotation 1.2s linear infinite;}@keyframes rotation{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const SpinnerContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__SpinnerContainer",
  componentId: "sc-1px4pjl-18"
})(["display:flex;align-items:center;justify-content:center;margin-top:100px;"]);
const HubspotFormContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__HubspotFormContainer",
  componentId: "sc-1px4pjl-19"
})(["iframe{height:632px !important;overflow:visible !important;}"]);
const LearnMoreButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "paywall-modalstyles__LearnMoreButton",
  componentId: "sc-1px4pjl-20"
})(["svg{width:20px;margin-left:6px;}color:", ";"], colors.gray800);

const Step0 = props => {
  const {
    bannerGradient,
    bannerSrc,
    showPremium,
    title,
    bulletPoints = [],
    bannerImgStyle,
    caption
  } = props;
  return jsxs(Fragment, {
    children: [jsx(Banner, Object.assign({
      gradient: bannerGradient
    }, {
      children: bannerSrc && jsx("img", {
        src: bannerSrc,
        alt: "",
        style: bannerImgStyle
      })
    })), jsx(Body, {
      children: jsxs(BodyContent, {
        children: [caption && jsx(Typography, Object.assign({
          marginBottom: "8px",
          variant: "caption",
          color: "gray600",
          fontWeight: "semibold",
          letterSpacing: '0.7px'
        }, {
          children: caption
        })), jsxs(FlexBox, Object.assign({
          alignItems: "center"
        }, {
          children: [jsx(Typography, Object.assign({
            variant: "h2",
            color: "textPrimary"
          }, {
            children: title
          })), showPremium && jsx(PremiumTag, {
            children: "Premium"
          })]
        })), jsx(BulletPointContainer, {
          children: bulletPoints.map((bulletPoint, index) => jsxs(FlexBox, Object.assign({
            alignItems: "center",
            className: "bulletpoint"
          }, {
            children: [jsx(ArrowCircle, {}), jsx(Typography, Object.assign({
              variant: "body",
              color: "textPrimary"
            }, {
              children: bulletPoint
            }))]
          }), index))
        })]
      })
    })]
  });
};

const HubspotForm = props => {
  const {
    portalId,
    formId,
    onSubmit,
    cssClass,
    formElementId,
    companyName,
    customer_id,
    utmSource
  } = props;
  const [isLoaded, setIsLoaded] = React.useState(false);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/shell.js';
    document.body.appendChild(script);
    script.addEventListener('load', () => {
      // @TS-ignore
      if (window.hbspt) {
        // @TS-ignore
        window.hbspt.forms.create({
          region: 'na1',
          portalId: portalId,
          formId: formId,
          target: `#${formElementId}`,
          cssClass: cssClass,
          submitButtonClass: 'hub-spot-form-submit-button'
        });
      }
    });
    const submitHandler = event => {
      var _a, _b, _c, _d, _e, _f, _g;
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        if (event.data.id === formId) {
          onSubmit();
        }
      } else {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
          setIsLoaded(true);
          const iframe = document.getElementsByClassName('hs-form-iframe')[0];
          const link = document.createElement('style');
          link.textContent = formCSS;
          (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.head.appendChild(link);
          (_c = (_b = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _b === void 0 ? void 0 : _b.document.querySelector("input[name='company']")) === null || _c === void 0 ? void 0 : _c.setAttribute('value', `${companyName}`);
          (_e = (_d = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _d === void 0 ? void 0 : _d.document.querySelector("input[name='customer_id']")) === null || _e === void 0 ? void 0 : _e.setAttribute('value', `${customer_id}`);
          (_g = (_f = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _f === void 0 ? void 0 : _f.document.querySelector("input[name='utm_source']")) === null || _g === void 0 ? void 0 : _g.setAttribute('value', `${utmSource}`);
        }
      }
    };
    window.addEventListener('message', submitHandler);
    return () => {
      window.removeEventListener('message', submitHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsxs(Fragment, {
    children: [jsx(HubspotFormContainer, {
      children: jsx("div", {
        id: formElementId
      })
    }), !isLoaded && jsx(SpinnerContainer, {
      children: jsx(Spinner, {})
    })]
  });
};

const Step1 = props => {
  const {
    onSubmit,
    onBack,
    portalId,
    formId,
    companyName,
    customerId,
    utmSource
  } = props;
  return jsxs(Fragment, {
    children: [jsxs(FormHeader, {
      children: [jsx("button", Object.assign({
        onClick: onBack
      }, {
        children: jsx(ChevronLeft, {})
      })), jsx(Typography, Object.assign({
        fontSize: 16,
        fontWeight: "bold",
        variant: "h2"
      }, {
        children: "Contact us for a demo"
      }))]
    }), jsxs("div", Object.assign({
      style: {
        position: 'relative'
      }
    }, {
      children: [jsx(Typography, Object.assign({
        variant: "body",
        color: "gray800",
        style: {
          padding: '24px 20px'
        }
      }, {
        children: "Interested? Let us know the best way to reach you."
      })), jsx(HubspotForm, {
        portalId: portalId,
        formId: formId,
        onSubmit: onSubmit,
        cssClass: "hub-spot-form",
        formElementId: "hubspotform",
        companyName: companyName,
        customer_id: customerId,
        utmSource: utmSource
      }), jsx(FormLine, {}), jsx(FormBackButton, Object.assign({
        onClick: onBack
      }, {
        children: "Back"
      }))]
    }))]
  });
};

var img$2 = "data:image/svg+xml,%3csvg width='154' height='150' viewBox='0 0 154 150' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M71.6498 144.021C92.1601 147.323 111.467 133.392 114.773 112.904C118.08 92.4161 104.133 73.1301 83.6225 69.8275C63.1122 66.5249 43.8052 80.4564 40.499 100.944C37.1928 121.432 51.1395 140.718 71.6498 144.021Z' fill='%23ECFAF8' stroke='%23ECFAF8' stroke-width='5'/%3e%3cpath d='M58.0517 105.006L71.004 119.97L85.7051 107.484L100.406 94.9985' stroke='%233AA79A' stroke-width='6'/%3e%3cpath d='M130.759 44.8385C133.025 50.1816 132.332 55.0751 128.705 59.5069L120.529 58.4742C124.786 56.0378 126.041 51.3328 123.302 43.6237L130.759 44.8385Z' fill='%23457CFF'/%3e%3cpath d='M144.486 80.5686C141.706 85.6722 137.446 88.1729 131.713 88.1206L127.409 81.1029C131.98 82.907 136.45 80.9581 140.781 74.0044L144.486 80.5686Z' fill='%23F7B950'/%3e%3cpath d='M74.0244 82.5247C77.9688 78.2337 82.6913 76.8273 88.2414 78.249L90.7327 86.0876C86.7285 83.2435 81.9211 84.078 76.0425 89.7848L74.0244 82.5247Z' fill='%23D88C9A'/%3e%3cpath d='M92.0875 37.9669C86.3095 38.5866 81.7845 36.4989 78.5903 31.7729L81.9383 24.2304C83.0496 28.9972 87.2291 31.5625 95.404 31.1634L92.0875 37.9669Z' fill='%23F7B950'/%3e%3cpath d='M116.627 80.4789C113.841 85.5733 109.566 88.0636 103.834 88.0034L99.5565 80.9738C104.127 82.7858 108.59 80.8277 112.941 73.9015L116.627 80.4789Z' fill='%23457CFF'/%3e%3cpath d='M71.8213 55.3339C66.7288 52.5332 64.2296 48.2229 64.3366 42.5271L71.4073 38.2664C69.5831 42.8122 71.5248 47.304 78.4473 51.6658L71.8213 55.3339Z' fill='%23457CFF'/%3e%3cpath d='M24.9169 110.333C24.2584 116.105 21.2441 120.014 15.9072 122.105L9.28731 117.201C14.1557 117.185 17.6032 113.703 19.0189 105.627L24.9169 110.333Z' fill='%23D88C9A'/%3e%3cpath d='M95.9858 57.7915C95.3272 63.5641 92.3051 67.4717 86.976 69.5637L80.3562 64.6598C85.2641 64.6505 88.6721 61.1618 90.0877 53.0862L95.9858 57.7915Z' fill='%23D88C9A'/%3e%3cpath d='M148.188 24.5397C147.53 30.3044 144.508 34.2119 139.179 36.304L132.559 31.4C137.428 31.3843 140.875 27.902 142.291 19.8264L148.188 24.5397Z' fill='%23D88C9A'/%3e%3cpath d='M58.359 67.0077C55.3357 71.9711 50.9508 74.2506 45.2348 73.9151L41.2869 66.6885C45.7455 68.7379 50.3047 67.0002 54.9829 60.2639L58.359 67.0077Z' fill='%23F7B950'/%3e%3cpath d='M40.071 104.945C34.7057 107.188 29.8192 106.468 25.3876 102.835L26.4416 94.6705C28.8314 98.9074 33.5594 100.221 41.3141 97.5112L40.071 104.945Z' fill='%23457CFF'/%3e%3cpath d='M6.59388 78.7583C7.93841 73.1055 11.4081 69.5864 16.9541 68.1524L22.9399 73.8103C18.0589 73.2579 14.2531 76.3017 11.8786 84.1403L6.59388 78.7583Z' fill='%23F7B950'/%3e%3c/svg%3e";

const Step2 = props => {
  const {
    confirmationTitle,
    confirmationText,
    onClose,
    footerLink
  } = props;
  const onLearnMore = () => {
    window.open(footerLink === null || footerLink === void 0 ? void 0 : footerLink.src);
  };
  return jsxs(Step2Container, {
    children: [jsx("img", {
      src: img$2,
      alt: "",
      style: {
        marginBottom: '60px'
      }
    }), jsx(Typography, Object.assign({
      variant: "h1",
      fontSize: 16,
      fontWeight: "bold",
      color: "textPrimary",
      style: {
        marginBottom: '20px'
      }
    }, {
      children: confirmationTitle
    })), jsx(Typography, Object.assign({
      variant: "body",
      style: {
        marginBottom: '60px'
      }
    }, {
      children: confirmationText
    })), jsxs(FooterButtonContainer, {
      children: [jsx(Button, Object.assign({
        onClick: onClose
      }, {
        children: "Done"
      })), (footerLink === null || footerLink === void 0 ? void 0 : footerLink.src) && jsxs(ConfirmButton, Object.assign({
        onClick: onLearnMore
      }, {
        children: [footerLink.text, " ", jsx(ExternalLink, {})]
      }))]
    })]
  });
};

const PaywallModal = props => {
  const {
    onClose,
    isOpen,
    maskClosable = true,
    footerLink,
    portalId,
    formId,
    companyName,
    customerId,
    centered = true,
    closeIcon = true,
    // default 1k from antd
    zIndex = 1000,
    onStepChange,
    initialStep = 0,
    utmSource,
    isCFA,
    isLoading
  } = props;
  const [step, setStep] = React.useState(initialStep);
  useEffect(() => {
    onStepChange && onStepChange(step);
  }, [step, onStepChange]);
  const footer = () => {
    let content = null;
    if (step === 0) {
      content = jsxs(Fragment, {
        children: [jsx("div", {
          children: (footerLink === null || footerLink === void 0 ? void 0 : footerLink.src) && (footerLink === null || footerLink === void 0 ? void 0 : footerLink.type) === 'link' && jsxs(FooterLink, Object.assign({
            href: footerLink.src,
            target: "_blank"
          }, {
            children: [footerLink.text, " ", jsx(ExternalLink, {})]
          }))
        }), jsxs(FooterButtonContainer, {
          children: [(footerLink === null || footerLink === void 0 ? void 0 : footerLink.type) !== 'button' ? jsx(ButtonNew, Object.assign({
            onClick: onClose
          }, {
            children: "Close"
          })) : jsxs(LearnMoreButton, Object.assign({
            onClick: () => window.open(footerLink === null || footerLink === void 0 ? void 0 : footerLink.src, '_blank')
          }, {
            children: [footerLink === null || footerLink === void 0 ? void 0 : footerLink.text, " ", jsx(ExternalLink, {})]
          })), isCFA ? jsx(ConfirmButton, Object.assign({
            loading: isLoading,
            onClick: () => {
              window.open('https://www.workstream.us/cfa-documents', '_blank');
            },
            type: "primary"
          }, {
            children: "Ready to sign up? Click here"
          })) : jsx(ConfirmButton, Object.assign({
            loading: isLoading,
            onClick: () => setStep(1),
            type: "primary"
          }, {
            children: "Contact us for a demo"
          }))]
        })]
      });
    }
    return jsx(Footer, Object.assign({
      hasBorder: step === 1
    }, {
      children: content
    }));
  };
  return jsx(PWModal, Object.assign({
    visible: isOpen,
    maskClosable: maskClosable,
    onCancel: onClose,
    footer: footer(),
    showFooter: step === 0,
    centered: centered,
    closeIcon: closeIcon,
    zIndex: zIndex,
    showClose: closeIcon
  }, {
    children: jsxs(Container, Object.assign({}, step === 1 && {
      height: 632
    }, {
      children: [step === 0 && jsx(Step0, Object.assign({}, props)), step === 1 && jsx(Step1, {
        onSubmit: () => {
          setStep(2);
        },
        onBack: () => setStep(0),
        portalId: portalId,
        formId: formId,
        companyName: companyName,
        customerId: customerId,
        utmSource: utmSource
      }), step === 2 && jsx(Step2, Object.assign({}, props))]
    }))
  }));
};

/**
 * A higher order component that wraps a multi-select to give a consistent server side
 * searching UX throughout the HR website.
 * Features:
 *  - Stores the option state of the previously selected values.
 *  - Clears the form input when the form is no longer focused.
 */
const withServerSideSearching = WrappedComponent => {
  return props => {
    const {
        serverSearch,
        options,
        loading
      } = props,
      others = __rest(props, ["serverSearch", "options", "loading"]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [showSelected, setShowSelected] = useState(false);
    const doSearch = debounce(input => {
      setShowSelected(!input);
      serverSearch(input);
    }, 250);
    const onSelect = value => {
      if (selectedOptions.filter(so => so.value === value).length) {
        setSelectedOptions(selectedOptions.filter(sr => sr.value !== value));
      } else {
        setSelectedOptions([...selectedOptions, ...(options || []).filter(o => o.value === value)]);
      }
    };
    const onBlur = () => {
      setShowSelected(true);
    };
    return jsx(WrappedComponent, Object.assign({
      loading: loading,
      onSearch: value => doSearch(value),
      onBlur: onBlur,
      onSelect: onSelect,
      options: showSelected ? selectedOptions : options
    }, others));
  };
};

var img$1 = "data:image/svg+xml,%3csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M2.87655 7.24918C2.98683 7.36037 3.11803 7.44863 3.26259 7.50885C3.40715 7.56908 3.56221 7.60009 3.71881 7.60009C3.87542 7.60009 4.03047 7.56908 4.17503 7.50885C4.31959 7.44863 4.45079 7.36037 4.56107 7.24918L9.40112 2.40914C9.62451 2.18575 9.75 1.88278 9.75 1.56687C9.75 1.25096 9.62451 0.947991 9.40112 0.724609C9.17774 0.501227 8.87477 0.375732 8.55886 0.375732C8.24295 0.375732 7.93998 0.501227 7.7166 0.724609L3.71881 4.73426L2.2834 3.28699C2.06002 3.06361 1.75705 2.93811 1.44114 2.93811C1.12523 2.93811 0.822259 3.06361 0.598877 3.28699C0.375495 3.51037 0.25 3.81334 0.25 4.12925C0.25 4.44516 0.375495 4.74813 0.598877 4.97151L2.87655 7.24918Z' fill='white' /%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='10' height='4' viewBox='0 0 10 4' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M8.9375 0.879883H1.0625C0.913316 0.879883 0.770242 0.99841 0.664753 1.20939C0.559263 1.42037 0.5 1.70651 0.5 2.00488C0.5 2.30325 0.559263 2.5894 0.664753 2.80038C0.770242 3.01136 0.913316 3.12988 1.0625 3.12988H8.9375C9.08668 3.12988 9.22976 3.01136 9.33525 2.80038C9.44074 2.5894 9.5 2.30325 9.5 2.00488C9.5 1.70651 9.44074 1.42037 9.33525 1.20939C9.22976 0.99841 9.08668 0.879883 8.9375 0.879883Z' fill='white' /%3e%3c/svg%3e";

const StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled-checkbox__StyledWrapper",
  componentId: "sc-1mr9qei-0"
})(["display:flex;align-items:center;column-gap:10px;cursor:pointer;.checkbox{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;box-sizing:border-box;background:#fff;border:1px solid #d4d4d8;border-radius:4px;cursor:pointer;flex-shrink:0;}.text{min-width:0px;overflow:hidden;text-overflow:ellipsis;}&:hover,&.checked{.checkbox{border-color:#787883;}}&.checked{.checkbox{background-color:#787883;}}.checkbox-form{width:20px;height:20px;}"]);
/**
 * Used by components in `multi-select` folder specifically.
 */
const StyledCheckbox = props => {
  const {
    checked,
    onChange,
    indeterminate,
    children,
    style,
    className,
    isForm,
    disabled
  } = props;
  return jsxs(StyledWrapper, Object.assign({
    style: style,
    className: `${checked || indeterminate ? 'checked' : ''} ${className || ''}`,
    onClick: event => {
      if (!disabled) {
        event.stopPropagation();
        event.preventDefault();
        onChange === null || onChange === void 0 ? void 0 : onChange({
          target: {
            checked: !checked || indeterminate
          }
        });
      }
    }
  }, {
    children: [jsxs("div", Object.assign({
      className: `checkbox ${isForm ? 'checkbox-form' : ''}`
    }, {
      children: [indeterminate ? jsx("img", {
        src: img,
        alt: "checkbox"
      }) : null, checked && !indeterminate ? jsx("img", {
        src: img$1,
        alt: "checkbox"
      }) : null]
    })), children && jsx("div", Object.assign({
      className: "text"
    }, {
      children: children
    }))]
  }));
};

const OPTION_ALL_VALUE = 'all';

const GlobalStyle = /*#__PURE__*/createGlobalStyle([".ant4-select-dropdown .ant4-select-item-option{padding:8px 16px;font-size:14px;color:#000000;}.ant4-select-dropdown .ant4-select-item-option-selected:not(.ant4-select-item-option-disabled){background:transparent;}.ant4-select-dropdown .ant4-select-item-option-state{display:none;}.ant4-select-dropdown .ant4-select-item-option{padding:12px 16px;&:hover{background-color:", ";}}.ant4-select-item-option-active:not(.ant4-select-item-option-disabled){background-color:", ";}.ant4-select-multiple.ant4-select-focused .ant4-select-selection-placeholder > span{color:", " !important;}.ant4-select-multiple .ant4-select-selection-placeholder{font-size:14px;font-family:'Plus Jakarta Sans';width:85%;line-height:20px;}.ant4-select-dropdown{border-radius:12px;padding-top:8px;padding-bottom:8px;}.ant4-select-focused:not(.ant4-select-disabled).ant4-select:not(.an4-select-customize-input) .ant4-select-selector,.ant4-select:not(.ant4-select-disabled):hover .ant4-select-selector{border:1px solid ", ";box-shadow:none;}.ant4-select-dropdown .ant4-select-tree-switcher{display:none;}.ant4-select-dropdown .ant4-select-tree-checkbox{display:none;}.ant4-select-dropdown  .ant4-select-tree-treenode{padding-left:4px;padding-right:4px;transition:all 0.3s;&:hover{background-color:", ";}}.ant4-select-dropdown  .ant4-select-tree-node-content-wrapper{&:hover{background-color:", ";}}.ant4-tree-select-dropdown{padding-left:0px;padding-right:0px;}"], ({
  theme
}) => theme.colors.gray100, ({
  theme
}) => theme.colors.gray100, ({
  theme
}) => theme.colors.gray400, ({
  theme
}) => theme.colors.gray800, ({
  theme
}) => theme.colors.gray100, ({
  theme
}) => theme.colors.gray100);
const StyledBulkSelect = /*#__PURE__*/styled(_Select).withConfig({
  displayName: "styledmulti-select__StyledBulkSelect",
  componentId: "sc-dde6m5-0"
})([".ant4-select-multiple{border:1px solid ", ";border-radius:8px;padding:7px 16px;height:36px;}.ant4-select-selector{border-radius:8px !important;border:1px solid ", ";}.ant4-select-arrow{width:24px;height:24px;top:35%;cursor:pointer;}"], ({
  theme
}) => theme.colors.gray400, ({
  theme
}) => theme.colors.gray400);
const StyledTreeSelect = /*#__PURE__*/styled(_TreeSelect).withConfig({
  displayName: "styledmulti-select__StyledTreeSelect",
  componentId: "sc-dde6m5-1"
})([".ant4-select-multiple{border:1px solid ", ";border-radius:8px;padding:7px 16px;height:36px;}.ant4-select-selector{border-radius:8px !important;border:1px solid ", ";padding-left:12px;}.ant4-select-selection-item{display:none;}.ant4-select-arrow{width:24px;height:24px;top:35%;cursor:pointer;}.ant4-select-clear{display:none;}.ant4-select-selection-search{margin-left:0;}"], ({
  theme
}) => theme.colors.gray400, ({
  theme
}) => theme.colors.gray400);
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledmulti-select__Wrapper",
  componentId: "sc-dde6m5-2"
})(["display:flex;align-items:center;position:relative;"]);
const SpinWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledmulti-select__SpinWrapper",
  componentId: "sc-dde6m5-3"
})(["display:flex;align-items:center;justify-content:center;margin-top:4px;"]);
const NoDataWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledmulti-select__NoDataWrapper",
  componentId: "sc-dde6m5-4"
})(["display:flex;justify-content:center;color:", ";"], ({
  theme
}) => theme.colors.gray800);
const TreeNodeWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledmulti-select__TreeNodeWrapper",
  componentId: "sc-dde6m5-5"
})(["display:inline-flex;height:32px;gap:10px;align-items:center;padding:19px 7px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;"]);

const getDefaultPlaceholder = (open, selectedPlaceholder, allOption) => values => {
  if (allOption && values[0] === allOption.value) {
    return jsx(Text, Object.assign({
      color: "gray800"
    }, {
      children: allOption.title
    }));
  }
  if (values.length >= 1) {
    return jsx(Text, Object.assign({
      color: "gray800"
    }, {
      children: `${selectedPlaceholder} (${values.length})`
    }));
  }
  return '';
};
const spinner = loading => () => {
  return jsx(SpinWrapper, {
    children: jsx(_Spin, {
      spinning: loading
    })
  });
};
const noData = () => {
  return jsx(NoDataWrapper, Object.assign({
    style: {
      display: 'flex'
    }
  }, {
    children: "please refine your search"
  }));
};
const clearMenu = onChange => menu => {
  return jsxs(Fragment, {
    children: [menu, jsx(_Divider, {
      style: {
        margin: 0
      }
    }), jsx("button", Object.assign({
      style: {
        padding: '10px 16px',
        cursor: 'pointer'
      },
      onMouseDown: e => e.preventDefault(),
      onClick: () => onChange([], [])
    }, {
      children: jsx(Text, Object.assign({
        color: "blue500"
      }, {
        children: "Clear"
      }))
    }))]
  });
};
const dropdownRender = (loading, options, allowClear, onChange) => loading && spinner(loading) || !loading && options.length === 0 && noData || allowClear && clearMenu(onChange);

const MultiSelect = props => {
  const {
      options = [],
      mode = 'multiple',
      value,
      onChange,
      getPlaceholder,
      placeholder,
      selectedPlaceholder,
      useAll = {
        title: 'All',
        value: OPTION_ALL_VALUE
      },
      loading = false,
      allowClear,
      onDropdownVisibleChange,
      passAllData = false,
      useMoreOptionsTip = false,
      numberOfMoreOptions,
      moreOptionsTip
    } = props,
    rest = __rest(props, ["options", "mode", "value", "onChange", "getPlaceholder", "placeholder", "selectedPlaceholder", "useAll", "loading", "allowClear", "onDropdownVisibleChange", "passAllData", "useMoreOptionsTip", "numberOfMoreOptions", "moreOptionsTip"]);
  const theme = /*#__PURE__*/useTheme();
  const _useAll = useAll && typeof useAll === 'boolean' ? {
    title: 'All',
    value: OPTION_ALL_VALUE
  } : useAll;
  const _options = useAll && options.length > 1 ? [{
    title: _useAll.title,
    value: _useAll.value
  }, ...options] : options;
  const [open, setOpen] = useState(false);
  const valueSet = options.map(o => o.value);
  const valueRef = useRef(value);
  const _values = value || [];
  const _getPlaceholder = getPlaceholder || (_values.length ? getDefaultPlaceholder(open, selectedPlaceholder, _useAll) : () => placeholder);
  /**
   * Compose a custom onChange since we need to handle 'All' option
   */
  const handleChange = (v, options) => {
    var _a;
    let newValues = [..._values, ...v];
    if (value && value.indexOf(v[0]) !== -1) {
      newValues = [..._values.filter(val => val !== v[0])];
    }
    if (newValues !== valueRef.current && newValues !== value) {
      const newValueHasAll = useAll && newValues.includes(_useAll.value);
      const refHasAll = useAll && ((_a = valueRef.current) === null || _a === void 0 ? void 0 : _a.includes(_useAll.value));
      // 'All' is checked previously, now check an option other than 'All'
      if (refHasAll && newValues.length > 1) {
        onChange(valueSet.filter(vs => vs !== newValues[1]), options);
      }
      // 'All' is checked previously, now uncheck 'All'
      else if (newValueHasAll && refHasAll || newValueHasAll && passAllData && newValues.length > valueSet.length) {
        onChange([], []);
      }
      // 'All' is unchecked previously, now check 'All'
      else if (newValueHasAll && !refHasAll || useAll && newValues.length === valueSet.length && options.length > 1) {
        onChange(passAllData ? valueSet : [_useAll.value], options);
      } else {
        onChange(newValues, options);
      }
    }
    valueRef.current = newValues;
  };
  useEffect(() => {
    valueRef.current = value;
  }, [value]);
  const filterOption = (inputValue, option) => {
    var _a;
    return (_a = typeof (option === null || option === void 0 ? void 0 : option.title) === 'string' && option.title.toLowerCase().includes(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase())) !== null && _a !== void 0 ? _a : false;
  };
  const dropdownVisible = _open => {
    setOpen(_open);
    onDropdownVisibleChange && onDropdownVisibleChange(_open);
  };
  function renderMoreOptionsTip() {
    if (!useMoreOptionsTip) {
      return null;
    }
    if (moreOptionsTip != null) {
      return moreOptionsTip;
    }
    return jsxs(_Select.Option, Object.assign({
      disabled: true,
      value: "",
      style: {
        cursor: 'unset'
      }
    }, {
      children: ["and ", numberOfMoreOptions, " more..."]
    }));
  }
  return jsxs(Wrapper, {
    children: [jsx(GlobalStyle, {}), jsxs(StyledBulkSelect, Object.assign({
      value: [],
      open: open,
      dropdownClassName: "bulk-select-antd",
      onChange: (val, options) => {
        handleChange(val, options);
      },
      filterOption: filterOption,
      placeholder: _getPlaceholder(_values, options),
      tagRender: jsx(_Tag, {
        style: {
          display: 'none'
        }
      }),
      dropdownRender: dropdownRender(loading, options, !!allowClear, onChange),
      onDropdownVisibleChange: dropdownVisible,
      mode: mode,
      showArrow: true,
      suffixIcon: open ? jsx(SmallChevronUp, {
        size: 24,
        color: theme.colors.gray600
      }) : jsx(SmallChevronDown, {
        size: 24,
        color: theme.colors.gray600
      })
    }, rest, {
      children: [_options === null || _options === void 0 ? void 0 : _options.map(opt => {
        const label = jsx(Text, Object.assign({
          color: "gray800",
          fontSize: "14px",
          fontWeight: opt.value === _useAll.value && _values[0] === opt.value ? 600 : 400,
          lineHeight: "20px"
        }, {
          children: opt.title
        }));
        const indeterminate = opt.value === _useAll.value && _values.length > 0 && (passAllData ? _values.length !== valueSet.length : _values[0] !== _useAll.value);
        return jsx(_Select.Option, Object.assign({
          value: opt.value,
          title: opt.title
        }, {
          children: opt['hideCheckbox'] ? label : jsx(StyledCheckbox, Object.assign({
            disabled: true,
            checked: _values.includes(opt.value) || _values.length === 1 && _values[0] === _useAll.value || passAllData && _values.length === valueSet.length,
            indeterminate: indeterminate
          }, {
            children: label
          }))
        }), opt.value);
      }), renderMoreOptionsTip()]
    }))]
  });
};

const TreeSelect = props => {
  const {
      treeData = [],
      getPlaceholder,
      placeholder,
      selectedPlaceholder,
      useAll = {
        title: 'All',
        value: 'all'
      },
      passAllData = false,
      loading = false,
      value,
      onChange,
      allowClear,
      onDropdownVisibleChange
    } = props,
    rest = __rest(props, ["treeData", "getPlaceholder", "placeholder", "selectedPlaceholder", "useAll", "passAllData", "loading", "value", "onChange", "allowClear", "onDropdownVisibleChange"]);
  const _useAll = useAll && typeof useAll === 'boolean' ? {
    title: 'All',
    value: 'all'
  } : useAll;
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const theme = /*#__PURE__*/useTheme();
  const _getPlaceholder = getPlaceholder || ((value === null || value === void 0 ? void 0 : value.length) ? getDefaultPlaceholder(open, selectedPlaceholder, _useAll) : () => jsx(Text, Object.assign({
    color: "gray400"
  }, {
    children: placeholder
  })));
  const getLeafValues = children => {
    const maybeChildren = children === null || children === void 0 ? void 0 : children.map(child => child.children ? getLeafValues(child.children) : [child.value]).reduce((acc, val) => [...acc, ...val], []);
    return maybeChildren || [];
  };
  const itemSelected = (itemValue, children) => {
    const _value = useAll && value && value.length && value[0] === _useAll.value ? getLeafValues(treeData) : value;
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!children) {
      const childValues = getLeafValues(children);
      const hasAll = childValues === null || childValues === void 0 ? void 0 : childValues.every(v => _value === null || _value === void 0 ? void 0 : _value.includes(v));
      if (hasAll) {
        onChange((_value === null || _value === void 0 ? void 0 : _value.filter(v => !childValues.includes(v))) || []);
      } else {
        // Add all child values.
        onChangeHandleAll([...(_value || []), ...childValues]);
      }
      return;
    }
    if (_value === null || _value === void 0 ? void 0 : _value.includes(itemValue)) {
      onChange(_value.filter(v => v !== itemValue));
    } else {
      const newValues = [...(_value || []), itemValue];
      onChangeHandleAll(newValues);
    }
  };
  const onChangeHandleAll = newValues => {
    if (!_useAll) {
      onChange(newValues);
      return;
    }
    const childValues = getLeafValues(treeData);
    // All values checked
    if (childValues.every(childValue => newValues.includes(childValue))) {
      onChange(passAllData ? newValues : [_useAll.value]);
    } else {
      onChange(newValues);
    }
  };
  const getItemTitle = item => {
    const hasChildren = !!item.children && item.children.length > 0;
    const childValues = getLeafValues(item.children);
    const checked = _useAll && (value === null || value === void 0 ? void 0 : value.includes(_useAll.value)) || hasChildren && (childValues === null || childValues === void 0 ? void 0 : childValues.every(v => value === null || value === void 0 ? void 0 : value.includes(v))) || !hasChildren && (value === null || value === void 0 ? void 0 : value.includes(item.value));
    const indeterminate = !checked && hasChildren && (childValues === null || childValues === void 0 ? void 0 : childValues.some(v => value === null || value === void 0 ? void 0 : value.includes(v)));
    return jsx(TreeSelectItem, {
      title: item.title,
      onClick: () => itemSelected(item.value, item.children),
      checked: !!checked,
      indeterminate: !!indeterminate
    });
  };
  const getAllNode = () => {
    const childValues = getLeafValues(treeData);
    const allChecked = (value === null || value === void 0 ? void 0 : value.includes(_useAll.value)) || passAllData && childValues.every(childValue => value === null || value === void 0 ? void 0 : value.includes(childValue));
    const item = jsx(TreeSelectItem, {
      title: _useAll.title,
      onClick: () => onChange(allChecked ? [] : passAllData ? [...childValues] : [_useAll.value]),
      checked: !!allChecked,
      indeterminate: !allChecked && !!value && value.length > 0
    });
    return jsx(TreeNode, {
      searchTitle: _useAll.title,
      title: item,
      value: _useAll.value
    }, _useAll.value);
  };
  /**
   * Custom rendering function to include our own checkbox.
   * @param data The tree data as passed in from props
   * @returns The TreeNode's
   */
  const mapToTreeNodes = data => {
    const providedNodes = (data === null || data === void 0 ? void 0 : data.map(treeItem => jsx(TreeNode, Object.assign({
      title: getItemTitle(treeItem),
      value: treeItem.value,
      searchTitle: treeItem.title
    }, {
      children: mapToTreeNodes(treeItem.children)
    }), treeItem.value))) || [];
    return providedNodes;
  };
  const dropdownVisible = _open => {
    setOpen(_open);
    setSearch(!_open ? '' : search);
    onDropdownVisibleChange && onDropdownVisibleChange(_open);
  };
  const filterTreeNode = (searchValue, item) => {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const title = (_b = (_a = item === null || item === void 0 ? void 0 : item.title) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.title;
    const result = title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
    return result;
  };
  return jsxs(Wrapper, {
    children: [jsx(GlobalStyle, {}), jsx(StyledTreeSelect, Object.assign({
      open: open,
      popupClassName: "bulk-select-antd",
      placeholder: search ? '' : _getPlaceholder(value || [], treeData),
      maxTagCount: 0,
      tagRender: jsx(_Tag, {
        style: {
          display: 'none'
        }
      }),
      dropdownRender: dropdownRender(loading, treeData, !!allowClear, onChange),
      onDropdownVisibleChange: dropdownVisible,
      onSearch: _search => setSearch(_search),
      value: [],
      showArrow: true,
      suffixIcon: open ? jsx(SmallChevronUp, {
        size: 24,
        color: theme.colors.gray600
      }) : jsx(SmallChevronDown, {
        size: 24,
        color: theme.colors.gray600
      })
    }, rest, {
      treeCheckable: true,
      mode: "multiple",
      treeDefaultExpandAll: true,
      treeExpandedKeys: treeData.map(td => td.value),
      filterTreeNode: filterTreeNode
    }, {
      children: !useAll ? mapToTreeNodes(treeData) : [getAllNode(), ...mapToTreeNodes(treeData)]
    }))]
  });
};
const TreeSelectItem = ({
  title,
  checked,
  indeterminate,
  onClick
}) => jsxs(TreeNodeWrapper, Object.assign({
  onClick: onClick
}, {
  children: [jsx(StyledCheckbox, {
    checked: checked,
    indeterminate: indeterminate,
    onChange: onClick
  }), jsx(Text, {
    children: title
  })]
}));

const ServerSideMultiSelect = withServerSideSearching(MultiSelect);

function getIcon(type) {
  switch (type) {
    case 'info':
      return jsx(Info, {});
    case 'warning':
      return jsx(Warning, {});
    case 'success':
      return jsx(CheckmarkCircle, {});
    case 'error':
      return jsx(CircleCross, {});
    default:
      return jsx(Info, {});
  }
}
function openToast(type, props) {
  _notification[type](Object.assign(Object.assign({
    placement: 'topRight',
    duration: 2.5,
    closeIcon: jsx(Cross, {}),
    icon: getIcon(type)
  }, props), {
    className: `nfw-toast ${type}-nfw-toast ${props === null || props === void 0 ? void 0 : props.className}`,
    description: jsx(Text, Object.assign({
      fontSize: "14px"
    }, {
      children: props === null || props === void 0 ? void 0 : props.message
    })),
    message: jsx(Text, Object.assign({
      fontWeight: 600,
      fontSize: "14px"
    }, {
      children: props === null || props === void 0 ? void 0 : props.description
    }))
  }));
}

const ProgressBar$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "progress-barstyles__ProgressBar",
  componentId: "sc-1sxz9um-0"
})(["display:flex;width:100%;"]);
const ProgressItem$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "progress-barstyles__ProgressItem",
  componentId: "sc-1sxz9um-1"
})(["", ""], ({
  theme
}) => {
  return css(["flex:1;color:", ";margin-right:10px;display:inline-block;overflow:hidden;.line{width:100%;&:after{content:'';width:100%;height:5px;border-radius:3px;display:inline-block;background-color:", ";}}.title{font-weight:400;font-size:12px;font-family:'Segoe UI';line-height:16px;.icon-container{padding-right:3px;vertical-align:text-top;}}&.item-finish{color:", ";.line{&:after{background-color:", ";}}}&.item-active{color:", ";.line{&:after{background-color:", ";}}}&.item-attention{color:", ";.line{&:after{background-color:", ";}}}&.item-wait{color:", ";.line{&:after{background-color:", ";}}}&.item-error{color:", ";.line{&:after{background-color:", ";}}}&.item-disabled{opacity:0.35;}"], theme.colors ? theme.colors.gray600 : '', theme.colors.gray200, theme.colors.green400, theme.colors.green400, theme.colors.blue400, theme.colors.blue400, theme.colors.gold500, theme.colors.gold500, theme.colors.gray600, theme.colors.gray200, theme.colors.red400, theme.colors.red400);
});
const S = {
  ProgressBar: ProgressBar$1,
  ProgressItem: ProgressItem$1
};

/**
 * ProgressBar
 */
const ProgressBar = props => {
  const {
    children,
    current = 0,
    initial = 0,
    onChange
  } = props;
  const onChangeStep = changedStep => {
    if (onChange && current !== changedStep) {
      onChange(changedStep);
    }
  };
  return jsx(S.ProgressBar, {
    children: toArray(children).map((child, index) => {
      var _a;
      const stepNumber = initial + index;
      const childProps = Object.assign({
        active: stepNumber === current,
        key: index,
        stepNumber,
        onStepClick: onChange && onChangeStep
      }, (child === null || child === void 0 ? void 0 : child.props) || {});
      if (!((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.status)) {
        if (stepNumber === current) {
          childProps.status = 'active';
        } else if (stepNumber < current) {
          childProps.status = 'finish';
        } else {
          childProps.status = 'wait';
        }
      }
      return /*#__PURE__*/cloneElement(child, childProps);
    })
  });
};
const ProgressItem = props => {
  const {
    title,
    status,
    active,
    disabled = false,
    onStepClick,
    stepNumber = 0
  } = props;
  const classnames = classNames('progress-item', `item-${status}`, {
    'item-active': active,
    'item-disabled': disabled
  });
  return jsx(S.ProgressItem, Object.assign({
    className: classnames,
    onClick: () => {
      if (!disabled) {
        onStepClick && onStepClick(stepNumber);
      }
    }
  }, {
    children: jsxs("div", {
      children: [jsx("div", {
        className: "line"
      }), jsx("div", Object.assign({
        className: "title"
      }, {
        children: title
      }))]
    })
  }));
};

export { Avatar, UserAvatar as AvatarV2, CardV2, Checkbox, CheckboxGroup, Collapse, Container$1 as Container, CountrySelector, DatePicker, DatePickerDayJs, DirectUpload, DropDownMenu, DropdownPicker, DropdownSelect, Elevator, ElevatorLayout, Ellipsis, ErrorPlaceholder, Examples, FullWidthTable, Heading, HubspotForm, Indicator, InlineNote, Input, ListSearchInput, LoadingPlaceholder, ManualUpload, Menu, MultiSelect, Notification, NumberInput, OPTION_ALL_VALUE, Pagination, PaywallModal, Popover, ProgressBar, ProgressItem, Radio, RangePicker, RegionSelector, SSNInput, SearchInput, Select, ServerSideMultiSelect, SlidingPane, Switch, Table, TelInput, TextArea$1 as TextArea, TextAreaGrow, Tooltip, TooltipV2, TreeSelect, Upload, UserAvatar, WarnButton, createFullWidthTable, createTable, maxWidthMixin, openToast };
